(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["karin-product-variants"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('karin-variants')) return;

    function debounce(fn, wait) {
      var t;
      return function () {
        var ctx = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () {
          fn.apply(ctx, args);
        }, wait);
      };
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    class KarinVariants extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-karin-grid]');
        this.table = this.querySelector('[data-karin-table]');
        this.countEl = this.querySelector('[data-karin-count]');
        this.searchInput = this.querySelector('[data-karin-search]');
        this.suggestEl = this.querySelector('[data-karin-suggest]');
        this.clearEl = this.querySelector('[data-karin-clear]');
        this.emptyEl = this.querySelector('[data-karin-empty]');
        this.filters = Array.prototype.slice.call(this.querySelectorAll('[data-karin-filter]'));
        // When on, the swatch grid stays hidden until the visitor interacts with the filter bar
        // (clicks anywhere in it, applies a filter, or types a search). Once revealed it stays shown.
        this.hideUntilFilter = this.getAttribute('data-hide-until-filter') === 'true';
        // When on, the filter bar stays visible but the CONTENT (swatch grid / brush table) is hidden on
        // load — via that element's own [hidden] attribute — until the "Click here for other colours /
        // brush" CTA under Add to cart is clicked, which reveals it + scrolls to it. Independent of
        // hide-until-filter; both simply toggle the same hideTarget's visibility, so they compose.
        this.hideUntilCta = this.getAttribute('data-hide-until-cta') === 'true';
        this.barEl = this.querySelector('.karin-pv__bar');
        // The element hidden until interaction: the paint swatch grid, or (for brushes) the table wrap.
        this.hideTarget = this.grid || this.table;
        this.gridRevealed = false;
        this.openTile = null;
        this.suggestItems = [];
        this.activeSuggest = -1;

        this.index = [];
        var indexNode = this.querySelector('[data-karin-index]');
        if (indexNode) {
          try {
            this.index = (JSON.parse(indexNode.textContent) || {}).items || [];
          } catch (e) {
            this.index = [];
          }
        }

        if (this.grid) {
          this.items = Array.prototype.slice.call(this.grid.querySelectorAll('.karin-swatch'));
        } else if (this.table) {
          this.items = Array.prototype.slice.call(this.table.querySelectorAll('[data-karin-row]'));
        } else {
          this.items = [];
        }

        this.debouncedFilter = debounce(this.applyFilters.bind(this), 120);

        if (this.searchInput) {
          this.searchInput.addEventListener('input', this.onSearchInput.bind(this));
          this.searchInput.addEventListener('keydown', this.onSearchKeydown.bind(this));
          this.searchInput.addEventListener(
            'blur',
            function () {
              setTimeout(this.closeSuggest.bind(this), 120);
            }.bind(this)
          );
        }
        if (this.suggestEl) {
          this.suggestEl.addEventListener('mousedown', this.onSuggestMousedown.bind(this));
        }
        if (this.clearEl) {
          this.clearEl.addEventListener('click', this.clearAll.bind(this));
        }
        this.filters.forEach(
          function (f) {
            f.addEventListener(
              'change',
              function () {
                if (this.grid && f.getAttribute('data-karin-filter') === 'size') {
                  // Size filters the panel rows, not the grid tiles (grid + count stay unchanged).
                  this.applyRowFilters();
                  this.updateClear();
                } else {
                  this.applyFilters();
                }
              }.bind(this)
            );
          }.bind(this)
        );

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        // Hovering a size row previews that size's image in the panel's main image (same as clicking its
        // thumbnail). Delegated mouseover; a no-op on rows/sizes without a matching gallery thumbnail.
        this.addEventListener('mouseover', this.onRowHover.bind(this));

        // Image popup: the dialog is rendered inside the section; move it to <body> so it stacks above
        // everything and is unaffected by any positioned/clipped ancestor, then wire its clicks.
        this._modal = this.querySelector('[data-karin-lightbox]');
        if (this._modal) {
          document.body.appendChild(this._modal);
          this._onModalClick = this.onModalClick.bind(this);
          this._modal.addEventListener('click', this._onModalClick);
          // Slide between images by dragging (mouse), swiping (touch) or scrolling (wheel) on the image.
          var mainEl = this._modal.querySelector('.karin-lightbox__main');
          if (mainEl) {
            this._lbDown = this.onLbPointerDown.bind(this);
            this._lbMove = this.onLbPointerMove.bind(this);
            this._lbUp = this.onLbPointerUp.bind(this);
            this._lbWheel = this.onLbWheel.bind(this);
            mainEl.addEventListener('pointerdown', this._lbDown);
            mainEl.addEventListener('pointermove', this._lbMove);
            mainEl.addEventListener('pointerup', this._lbUp);
            mainEl.addEventListener('pointercancel', this._lbUp);
            mainEl.addEventListener('wheel', this._lbWheel, { passive: false });
            this._lbMain = mainEl;
          }
        }

        // The theme's native add-to-cart is left untouched. We only: (1) show the max-quantity notice inside
        // the swatch/brush table (its own row), and (2) stop the page jumping to the top when the cart drawer
        // opens. The jump happens because the theme focuses the drawer (close button / first line item) via
        // FoxTheme.a11y.trapFocus WITHOUT `preventScroll`. We fix that at the root (patchModalFocus) and also
        // keep a scroll-restore fallback. Neither changes any cart behaviour.
        this.activeForm = null;
        this.errorArmed = false;
        this.patchModalFocus();
        this.addEventListener('submit', this.onSubmit.bind(this));
        this._onCartError = this.onCartError.bind(this);
        this._onCartAdded = this.onCartAdded.bind(this);
        document.addEventListener('product-ajax:error', this._onCartError);
        document.addEventListener('product-ajax:added', this._onCartAdded);

        if (this.grid) {
          this._onResize = debounce(this.repositionOpen.bind(this), 150);
          window.addEventListener('resize', this._onResize);
        }

        this.applyFilters();
        // Rows stay in backend (metaobject) order by default — we do NOT reorder on load. We only SHOW
        // the price column's caret pointing down (like the reference) as the default indicator; the row
        // order changes only when the user actually clicks a header.
        this.showDefaultSortCaret();
        // Wire the "More options" CTA (rendered below Add to cart) to scroll to this options grid.
        this.wireMoreOptionsCta();
        // Set up infinite scroll: auto-load the paint-grid remainder as it scrolls into view (no-op for
        // brushes / when there's no remainder).
        this.initLoadMore();
        // Keep the sticky filter bar flush against the theme header (no gap), even when the header hides
        // on scroll-down.
        this.initStickyBar();
        // "Second image of first linked product" swatch source: fetch each visible tile's 2nd product
        // image client-side and swap it in (no-op unless the setting stamped data-karin-second-image tiles).
        this.initSecondSwatchImages();
      }

      // Pin the filter bar flush to the BOTTOM of the theme header with no gap. The theme's sticky header
      // hides on scroll-down and shows on scroll-up, so its occupied height changes; a fixed CSS
      // `top: var(--header-height)` would leave an empty gap whenever the header is hidden. We instead
      // track the header's live bottom edge each frame and set the bar's top to it (clamped to 0 when the
      // header has scrolled away). Falls back to the CSS value if no header is found.
      initStickyBar() {
        if (!this.barEl) return;
        if (this.getAttribute('data-sticky-bar') !== 'true') return; // disabled in section settings
        var header = document.querySelector(
          '.header-section header[is="sticky-header"], .header-section header[is="basic-header"], .header-section header, header[is="sticky-header"], header[is="basic-header"]'
        );
        if (!header) return;
        // Measure the PINNED row only. The theme's header is `.header__top` (logo/search — stays stuck)
        // plus a navigation row that hides on scroll-down. The whole <header> keeps the nav's height in
        // its box even when hidden, so measuring the <header> left an ~80px gap (nav-height) between the
        // real pinned row and our bar. `.header__top` is the actually-visible pinned part.
        var measureEl = header.querySelector('.header__top') || header;
        var bar = this.barEl;
        var ticking = false;
        function update() {
          ticking = false;
          var bottom = measureEl.getBoundingClientRect().bottom;
          if (bottom < 0) bottom = 0;
          bar.style.top = bottom + 'px';
        }
        function onScroll() {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
          }
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
      }

      // Load More (paints only)
      // ------------------------
      // Reveals the remainder of the range beyond the curated first-50. The remainder for pagination
      // page 1 is already in the DOM inside a hidden <template data-karin-remainder>; the first click
      // consumes it with NO network request. Later pages are fetched via the Section Rendering API
      // (?section_id=&page=N) and this same template is read out of the returned HTML. Appended nodes
      // are imported into the live grid and pushed into this.items; all interactive behaviour (open
      // panel, sort, thumbnails, zoom, add-to-cart) already works on them because those handlers are
      // delegated on the component root. FAIL-SAFE: the button is revealed ONLY here, after a successful
      // bind — if this method never runs (or bails), the curated 50 render untouched and the button
      // stays hidden.
      initLoadMore() {
        if (!this.grid) return;
        this.lmWrap = this.querySelector('[data-karin-loadmore]');
        // The remainder now comes from the dedicated lean endpoint (sections/karin-swatch-remainder.liquid)
        // so the product page renders no inline remainder <template> — the heavy store-wide metaobject scan
        // no longer runs on page views. An inline template is still consumed if present (back-compat).
        this.lmTemplate = this.querySelector('[data-karin-remainder]');
        if (!this.lmWrap) return;
        this.lmBtn = this.lmWrap.querySelector('[data-karin-loadmore-btn]');
        this.lmError = this.lmWrap.querySelector('[data-karin-loadmore-error]');

        // Seed the dedupe set from the curated handles already in the grid.
        this._lmSeen = {};
        for (var i = 0; i < this.items.length; i++) {
          var h = this.items[i].getAttribute('data-colour-handle');
          if (h) this._lmSeen[h] = true;
        }
        // Collect-only buffer for the "Load more" remainder. Colours are fetched in global metaobject order
        // (NOT chart order) and across several pages, so we do NOT drop them into the grid as they arrive —
        // that showed them jumbled and then visibly re-ordered them. Every fetched colour is collected here;
        // once the whole remainder has loaded it is sorted ONCE by product code and revealed in correct order
        // in a single batch, so the grid only ever shows colours already in order (see flushRemainder).
        this._lmBuffer = [];

        // Section Rendering endpoint hints. _lmUrl (Liquid product.url) is the LOCALE-SAFE fetch base —
        // correct locale prefix + locale-translated handle in one; _lmHandle is the legacy fallback.
        this._lmUrl = this.lmWrap.getAttribute('data-product-url') || '';
        this._lmHandle = this.lmWrap.getAttribute('data-product-handle') || '';
        this._lmSectionId = this.lmWrap.getAttribute('data-section-id') || '';

        // RANGE-CACHE FAST-PATH: a previous product page of this SAME range already discovered the whole
        // remainder this session and cached it (see _maybeCacheRemainder). Hydrate straight from
        // sessionStorage: zero fetches, no store-wide metaobject scan, every colour lands immediately and in
        // final chart order. An empty string is a hit too — it means "this range has no remainder at all"
        // (e.g. exactly 50 colours), letting those pages skip the discovery fetch entirely. Skipped in the
        // theme editor so merchants always see fresh data there. The loader UI never shows on this path.
        if (!(window.Shopify && window.Shopify.designMode)) {
          var cachedRm = null;
          try {
            var rmKey = this._rmCacheKey();
            cachedRm = rmKey ? sessionStorage.getItem(rmKey) : null;
          } catch (e) {
            cachedRm = null;
          }
          if (cachedRm !== null) {
            this._rmFromCache = true;
            this._lmExhausted = true;
            if (cachedRm) {
              var rmTpl = document.createElement('template');
              rmTpl.innerHTML = cachedRm;
              this.appendRemainder(rmTpl);
              this.flushRemainder(); // streams in chunks; its finalise re-marks this page's current colour
            }
            return;
          }
        }

        // Pagination state. With no inline template the page count is UNKNOWN until the first fetch of the
        // dedicated endpoint returns — each fetched template carries data-total-pages / data-page-param and
        // _lmFetchPage updates these from it. Start at 1 total, 'page' param (page 1 needs no param anyway).
        this._lmPage = 1;
        this._lmTotal = this.lmTemplate ? parseInt(this.lmTemplate.getAttribute('data-total-pages') || '1', 10) : 1;
        if (isNaN(this._lmTotal) || this._lmTotal < 1) this._lmTotal = 1;
        // The ACTUAL pagination URL param name for shop.metaobjects (Shopify may use a unique key, not
        // the literal "page" — which is why a hardcoded &page=N was being ignored and it stuck mid-way).
        this._lmParam = (this.lmTemplate && this.lmTemplate.getAttribute('data-page-param')) || 'page';
        // Endpoint path signal (data-fast on a fetched template): true = the range's colour_handles fast
        // path, where each page is ≤18 direct handle look-ups — the fetch pool may then raise its
        // concurrency cap. Defaults false (the store-scan fallback keeps the conservative cap).
        this._lmFast = false;
        this._lmBusy = false;
        this._lmExhausted = false;
        this._lmDone = 0; // how many pages (bunches) have been loaded so far; one per click

        // Whether there ARE remainder colours to load. Two signals:
        //  (a) a legacy inline page-1 template with cards (older render still in a cache), OR
        //  (b) the curated list came back FULL (hit Liquid's 50-item cap on range.colours, so the range
        //      likely has MORE) — the dedicated endpoint is then fetched to discover the remainder.
        // A range with EXACTLY 50 colours fetches once, finds nothing new, and the loader hides — harmless,
        // the trade for guaranteed completeness.
        var page1HasCards = !!(this.lmTemplate && this.lmTemplate.content && this.lmTemplate.content.querySelector('.karin-swatch'));
        var maybeMore = this.lmWrap.getAttribute('data-maybe-more') === 'true';
        this._lmPage1Inline = page1HasCards; // consume the inline template for page 1 when it has cards
        if (!page1HasCards && !maybeMore) return;

        this._lmReady = true;
        // "Load more behaviour" section setting (data-loadmore-mode): 'auto' = load on scroll, 'button' = load
        // on click, 'both' = show the button AND auto-load on scroll. Default 'both'.
        this._lmMode = this.getAttribute('data-loadmore-mode') || 'both';
        var wantsButton = this._lmMode !== 'auto'; // 'button' or 'both'
        var wantsAuto = this._lmMode !== 'button'; // 'auto' or 'both'
        var self = this;

        // Button trigger — reveal + wire it in 'button'/'both' modes; keep it hidden otherwise. Both triggers
        // call onLoadMore(), whose _lmBusy/_lmExhausted guards make a click + a scroll fire safely coexist.
        if (this.lmBtn) {
          if (wantsButton) {
            this.lmBtn.hidden = false;
            this._onLoadMore = this.onLoadMore.bind(this);
            this.lmBtn.addEventListener('click', this._onLoadMore);
          } else {
            this.lmBtn.hidden = true;
          }
        }

        // Auto-load-on-scroll trigger — in 'auto'/'both' modes, watch the loader with an IntersectionObserver
        // and pull the remainder when it nears the viewport (rootMargin starts the load ~600px early). Observing
        // a hidden element reports no intersection, so this also stays dormant until the loader is revealed
        // (hide-until-filter/CTA) — revealing it then fires the callback if it's in view.
        if (wantsAuto && 'IntersectionObserver' in window) {
          this._lmObserver = new IntersectionObserver(
            function (entries) {
              for (var i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                  self.onLoadMore();
                  break;
                }
              }
            },
            { rootMargin: '600px 0px' }
          );
          this._lmObserver.observe(this.lmWrap);
        }
        // Fallback when auto is the ONLY trigger but IntersectionObserver is unavailable: load the remainder
        // outright on reveal so it's never unreachable ('button'/'both' modes already have a clickable button).
        this._lmAutoFallback = wantsAuto && !wantsButton && !this._lmObserver;

        // Reveal the loader now UNLESS the palette is gated behind a hide-until-filter / hide-until-CTA
        // interaction and hasn't been revealed yet. While gated, the loader stays hidden (so the observer
        // reports no intersection and never auto-loads) until revealLoadMore() — called when the palette is
        // revealed — un-hides it. This keeps auto-load from pulling the remainder while the palette is still
        // hidden (hide-until-CTA is on by default). In the theme editor the palette is never gated (mirrors the
        // server `unless request.design_mode`), so reveal it there.
        var inEditor = !!(window.Shopify && window.Shopify.designMode);
        var gatedHidden = !inEditor && (this.hideUntilFilter || this.hideUntilCta) && !this.gridRevealed;
        if (!gatedHidden) {
          this.lmWrap.hidden = false;
          if (this._lmAutoFallback) this.onLoadMore(); // no IntersectionObserver + auto-only: load right away
          this.prefetchRemainder(); // start loading NOW (idle), not when the loader scrolls into view
        }
      }

      // EAGER PREFETCH — the big perceived-speed win for colours past #50. Previously the remainder only
      // STARTED loading when the loader scrolled near the viewport, so the user scrolled, waited on the
      // fetch + sort, and only then saw the chunks. Now (in the auto/both load-more modes) the load kicks
      // off in idle time right after page init: by the time the visitor scrolls past the first 50 tiles the
      // sorted remainder is (usually) already buffered and painted, so it reads as instant. This bundle is
      // DEFERRED, so "right after page init" is still late in page load — karin-swatch-grid additionally
      // starts page 1's request inline DURING HTML PARSE (window.__karinRmPre, consumed by _lmFetchPage),
      // so by the time this runs the slowest request is usually already half-done. Safe: onLoadMore
      // is guarded (_lmBusy/_lmExhausted), so this coexists with the scroll observer + button; tile images
      // stay lazy (loading="lazy" + the second-image observer only fetches near-viewport tiles), so the
      // eager DOM build doesn't trigger an image-download storm or jank the page.
      prefetchRemainder() {
        if (this._lmMode === 'button') return; // merchant chose click-to-load — don't preempt it
        var self = this;
        // ALREADY-HOT SHORTCUT: the idle wrapper below exists to yield before STARTING a new network request.
        // When karin-swatch-grid's inline script has already started page 1 (an unconsumed entry on
        // window.__karinRmPre — created only under guards that mirror this method's own triggers), there is no
        // request left to defer: the only work ahead is consume + parse + paint, which flushRemainder already
        // chunks across frames. Waiting out requestIdleCallback's 300ms timeout would just delay collecting a
        // response that may already be sitting there. Non-emptiness is the right test (NOT a rebuilt page-1
        // URL — that would duplicate _lmFetchPage's base/param byte-parity logic into a second place); the map
        // only ever holds entries this theme's inline script created. Read-only: fetchText stays the sole
        // consumer, and onLoadMore's _lmBusy/_lmExhausted guards are untouched, so this changes WHEN the run
        // starts, never WHETHER it does.
        if (this._lmDone === 0) {
          var pre = window.__karinRmPre;
          var hot = false;
          if (pre) {
            for (var k in pre) {
              hot = true;
              break;
            }
          }
          if (hot) {
            Promise.resolve().then(function () {
              self.onLoadMore();
            });
            return;
          }
        }
        // Short timeout: yield to genuinely idle time when there is any, but never sit waiting on a busy
        // page for long — the remainder fetch is the longest pole (a server-side metaobject scan), so every
        // ms it starts earlier is a ms sooner the colours are on screen.
        var idle = window.requestIdleCallback
          ? function (cb) {
              window.requestIdleCallback(cb, { timeout: 300 });
            }
          : function (cb) {
              setTimeout(cb, 100);
            };
        idle(function () {
          self.onLoadMore();
        });
      }

      // Reveal the loader in lock-step with the swatch grid (used by the hide-until-filter paths). No-op unless
      // there's a remainder to load and it isn't exhausted. Without IntersectionObserver support, revealing it
      // also kicks off the load (the observer would otherwise be what triggers it).
      revealLoadMore() {
        if (this._lmReady && !this._lmExhausted && this.lmWrap) {
          this.lmWrap.hidden = false;
          if (this._lmAutoFallback) this.onLoadMore();
          this.prefetchRemainder(); // palette just revealed — start the remainder load immediately
        }
      }

      onLoadMore() {
        if (this._lmBusy || this._lmExhausted) return;
        this._lmBusy = true;
        if (this.lmWrap) this.lmWrap.classList.add('is-loading'); // shows the loading spinner
        if (this.lmError) this.lmError.hidden = true; // clear any prior error on a fresh attempt

        var self = this;
        // Keep the spinner on screen for a consistent minimum time. Page 1 is already in the DOM (instant) and
        // would otherwise flash no spinner, while later pages (a network fetch) show one — this floor makes the
        // load read consistently rather than flickering.
        var MIN_SPIN = 300;
        var startedAt = Date.now();

        function finish() {
          var doHide = function () {
            self._lmBusy = false;
            if (self.lmWrap) self.lmWrap.classList.remove('is-loading'); // hides the loading spinner
          };
          var elapsed = Date.now() - startedAt;
          if (elapsed < MIN_SPIN) {
            setTimeout(doHide, MIN_SPIN - elapsed);
          } else {
            doHide();
          }
        }

        function stop() {
          // Whole remainder has loaded. Pages already STREAMED into the grid as they arrived (see loadPage /
          // flushRemainder) — this final flush just drains anything still buffered. Exhausted is set FIRST so
          // the flush's finalise step knows the run is complete and may write the per-range session cache.
          self._lmExhausted = true;
          self.flushRemainder();
          if (self.lmWrap) self.lmWrap.hidden = true;
          // Fully loaded — stop watching so it never re-triggers.
          if (self._lmObserver) {
            self._lmObserver.disconnect();
            self._lmObserver = null;
          }
          finish();
        }

        // Load the WHOLE remainder in one run. The remainder is discovered by scanning ALL the store's
        // paint-colour metaobjects, which Shopify splits into pages. A range's leftover colours can sit on ANY
        // page — including the LAST one, because a colour added to the range later gets a newer metaobject that
        // paginates to the end — so we must walk EVERY page (1..total) and never stop early on an "empty" page,
        // or late-added colours would be missed. Each landed page is collected (appendRemainder) and then
        // STREAMED straight into the grid in sorted position (flushRemainder) — the visitor sees colours the
        // moment the first page arrives, not when the slowest page finishes.
        //
        // Consume one page and resolve once its colours have been collected + streamed. Page 1 comes from the
        // inline template only when a legacy render put one there; normally every page — including 1 — is
        // fetched from the dedicated lean endpoint (see _lmFetchPage).
        function loadPage(page) {
          if (page <= 1 && self._lmPage1Inline && self.lmTemplate) {
            // Defer so the spinner PAINTS before the (instant, synchronous) page-1 work blocks the main thread.
            return new Promise(function (resolve, reject) {
              setTimeout(function () {
                try {
                  self.appendRemainder(self.lmTemplate);
                  self.flushRemainder();
                  resolve();
                } catch (err) {
                  reject(err);
                }
              }, 0);
            });
          }
          return self._lmFetchPage(page).then(function (tmpl) {
            self.appendRemainder(tmpl);
            self.flushRemainder(); // stream this page's colours into position NOW — don't wait for the rest
          });
        }

        // One page, with retries. A transient failure retries the SAME page a few times (the spinner stays
        // up the whole time, so the loader visibly "continues"); a persistent failure SKIPS the page so the
        // run always reaches the end and the loader can never hang on an empty spinner. (Colours on a
        // permanently-unreachable page are the only ones that can't be shown; everything else still loads.)
        function loadPageWithRetry(page, attempt) {
          return loadPage(page).catch(function (err) {
            var tries = attempt || 0;
            if (tries < 3) {
              if (window.console && console.warn) console.warn('[karin] load more: retrying page ' + page, err);
              return new Promise(function (resolve) {
                setTimeout(resolve, 800);
              }).then(function () {
                return loadPageWithRetry(page, tries + 1);
              });
            }
            if (window.console && console.error) console.error('[karin] load more: skipped page ' + page, err);
            // A page is permanently missing → this run's remainder is INCOMPLETE. Never let it be written
            // to the per-range session cache, or every later page this session would miss those colours.
            self._lmHadFailure = true;
          });
        }

        // SPEED: pages 2..N load in PARALLEL as a ROLLING POOL (page 1 goes first alone — it reports the
        // real page count via data-total-pages AND the actual pagination param name every later URL needs;
        // the buffer-then-sort design, appendRemainder dedupe + flushRemainder merge-insert, never cared
        // about arrival order). A CONCURRENCY CAP keeps us from firing a whole range's pages at once: on
        // the FALLBACK path each page is a store-wide metaobject scan (the theme's most expensive render),
        // and a request storm can slow the page or trip server throttling (429 → retries exhausted → a
        // SKIPPED page = a silently missing colour), so that path keeps the proven cap of 3. On the FAST
        // colour_handles path (endpoint stamps data-fast="1"; a page is ≤18 direct handle look-ups, no
        // scan — comparable to any section render) the cap rises to 6, roughly halving multi-page wall
        // time. The pool launches the NEXT page the moment ANY in-flight page lands — unlike the previous
        // fixed batches of 3 behind a Promise.all barrier, which waited for each batch's SLOWEST page
        // before starting the next three. Behaviour/output is UNCHANGED: every page 1.._lmTotal is fetched
        // exactly once and streams into the grid in sorted position; the pool re-reads _lmTotal on every
        // launch, so pages a fetch revealed (a raised total) are picked up; stop() runs only once nothing
        // is in flight and nothing is left.
        var REMAINDER_CONCURRENCY = 3;
        var FAST_CONCURRENCY = 6;
        var nextPage = this._lmDone + 2; // the pool starts at the page after firstPage (fetched below)
        var active = 0;
        function pump() {
          var cap = self._lmFast ? FAST_CONCURRENCY : REMAINDER_CONCURRENCY;
          while (active < cap && nextPage <= self._lmTotal) {
            (function (page) {
              active++;
              loadPageWithRetry(page).then(function () {
                active--;
                self._lmDone++;
                pump();
              });
            })(nextPage++);
          }
          if (active === 0 && nextPage > self._lmTotal) stop();
        }

        var firstPage = this._lmDone + 1;
        loadPageWithRetry(firstPage).then(function () {
          self._lmDone = firstPage;
          pump();
        });
      }

      // Fetch the remainder <template> for pagination page N. PRIMARY: the dedicated lean endpoint —
      // `?page=N&section_id=karin-swatch-remainder` — a bare section file addressable by its FILENAME
      // (same mechanism as Shopify's own section_id=predictive-search) that renders ONLY the remainder
      // template: no curated grid, no filters, no search index. This is what makes each background fetch
      // cheap. FALLBACKS (older cached renders / missing file): the main section via its real section_id,
      // then the full product page. Every successful template also refreshes _lmTotal/_lmParam, since with
      // no inline template the true page count is only known from the endpoint's own paginate state.
      _lmFetchPage(page) {
        // LOCALE-SAFE base: prefer Liquid's product.url (correct locale prefix + locale-translated handle);
        // it fixes the remainder failing on a locale whose product handle differs (…-oil-paint-… vs
        // …-yagli-boya-…). Strip any query/hash, then append our own params. Fall back to handle + routes.root
        // only when product.url wasn't emitted (older cached markup).
        var base;
        if (this._lmUrl) {
          base = this._lmUrl.split('#')[0].split('?')[0];
        } else {
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          base = root + 'products/' + encodeURIComponent(this._lmHandle);
        }
        var param = encodeURIComponent(this._lmParam || 'page');
        var self = this;
        var urls = [base + '?' + param + '=' + page + '&section_id=karin-swatch-remainder'];
        if (this._lmSectionId) {
          urls.push(base + '?' + param + '=' + page + '&section_id=' + encodeURIComponent(this._lmSectionId));
        }
        urls.push(base + '?' + param + '=' + page);

        function extract(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var tmpl = doc.querySelector('[data-karin-remainder]');
          if (!tmpl) return null;
          var cur = parseInt(tmpl.getAttribute('data-current-page') || '0', 10);
          if (cur !== page) return null; // must be exactly the page we asked for
          // Adopt the endpoint's own pagination state: total pages + the real page-param name (Shopify may
          // use a unique key for metaobject pagination, and it can differ per section).
          var total = parseInt(tmpl.getAttribute('data-total-pages') || '0', 10);
          if (!isNaN(total) && total > 0) self._lmTotal = total;
          var p = tmpl.getAttribute('data-page-param');
          if (p) self._lmParam = p;
          // Path signal: only the endpoint's colour_handles fast path stamps data-fast="1" (older cached
          // endpoint copies / the fallback scan don't → stays false → conservative concurrency).
          self._lmFast = tmpl.getAttribute('data-fast') === '1';
          return tmpl;
        }

        // EARLY-PREFETCH consumption: karin-swatch-grid emits a tiny inline script that starts the page-1
        // endpoint fetch DURING HTML PARSE — long before this deferred bundle runs — and parks the
        // in-flight promise on window.__karinRmPre keyed by the EXACT url (resolves to the response text,
        // or null on any failure). Consume a matching entry instead of re-fetching; entries are one-shot
        // (deleted on pickup) so a retry after a failure always does a REAL fetch. A null (failed) preload
        // falls through to a normal fetch of the same url — byte-for-byte today's behaviour.
        function fetchText(url) {
          var pre = window.__karinRmPre;
          var preloaded = pre && pre[url];
          if (preloaded) {
            delete pre[url];
            return preloaded.then(function (text) {
              return text !== null && text !== undefined ? text : realFetch(url);
            });
          }
          return realFetch(url);
        }
        function realFetch(url) {
          return fetch(url).then(function (resp) {
            if (!resp.ok) throw new Error('HTTP ' + resp.status + ' for ' + url);
            return resp.text();
          });
        }

        // Try each URL in order until one yields the right page's template.
        function tryUrl(i) {
          if (i >= urls.length) return Promise.reject(new Error('page ' + page + ' not applied'));
          return fetchText(urls[i])
            .then(function (html) {
              var tmpl = extract(html);
              return tmpl || tryUrl(i + 1);
            })
            .catch(function () {
              return tryUrl(i + 1);
            });
        }
        return tryUrl(0);
      }

      // Import a remainder <template>'s children (a flat, alternating sequence of .karin-swatch buttons and
      // their sibling .karin-panel divs), skipping any colour whose handle was already seen (curated or an
      // earlier page). A skipped swatch's following panel is skipped too.
      // ORDER: Shopify caps a range's authored colour list at 50 items in Liquid, so colours beyond the 50th
      // arrive here in a global metaobject order, spread across pages. Each kept colour (swatch + panel +
      // sort key) is COLLECTED into this._lmBuffer; the caller then streams the batch into the grid via
      // flushRemainder, which sorts it and MERGE-INSERTS each colour at its correct position — so the grid
      // shows colours in chart order from the first page onward, and never a jumbled-then-re-ordered state.
      appendRemainder(templateEl) {
        if (!templateEl || !templateEl.content) return 0;
        if (!this._lmBuffer) this._lmBuffer = [];
        // importNode clones into THIS document so the nodes are adoptable (esp. from the fetched doc).
        var frag = document.importNode(templateEl.content, true);
        var nodes = Array.prototype.slice.call(frag.childNodes);
        var added = 0;
        var current = null;
        var skipPanel = false;
        for (var i = 0; i < nodes.length; i++) {
          var node = nodes[i];
          if (node.nodeType !== 1) continue; // ignore whitespace text nodes between cards
          if (node.classList && node.classList.contains('karin-swatch')) {
            var h = node.getAttribute('data-colour-handle');
            if (h && this._lmSeen[h]) {
              skipPanel = true; // duplicate colour — drop it and its panel
              current = null;
              continue;
            }
            if (h) this._lmSeen[h] = true;
            skipPanel = false;
            node.classList.add('karin-swatch--more'); // marks a loaded (vs curated) tile
            current = { swatch: node, panel: null, key: node.getAttribute('data-sort-key') || '' };
            this._lmBuffer.push(current); // collect — do NOT insert yet (see flushRemainder)
            added++;
          } else if (node.classList && node.classList.contains('karin-panel')) {
            if (skipPanel) {
              skipPanel = false;
              continue;
            }
            if (current) {
              current.panel = node;
              current = null;
            }
          }
        }
        return added;
      }

      // Reveal the buffered remainder as a SORTED-MERGE STREAM, in small chunks across animation frames.
      // Called after EVERY page (not just once at the end): the buffered colours are sorted by data-sort-key,
      // then each one is INSERTED at its correct position among the remainder tiles already in the grid —
      // both sides are sorted, so a single forward merge pointer finds every insertion point. Tiles already
      // on screen never move relative to each other and the sequence never reads out of order; later pages
      // simply slot their colours into place. Net effect: the first page PAINTS the moment it arrives (in
      // chart order) instead of the old buffer-everything-flush-at-the-end behaviour, which read as "loads at
      // the end and then fixes the order". Chunked inserts keep the tab responsive (cards are heavy: a panel
      // + a form per size). Re-entrant safe: one flush paints at a time — a page landing mid-flush queues and
      // drains immediately after (its merge pointer would otherwise go stale). Curated tiles never move.
      flushRemainder() {
        if (!this.grid) return 0;
        if (this._flushActive) {
          this._flushPending = true; // a flush is painting — its finalise step will re-run for this buffer
          return 0;
        }
        var buffer = this._lmBuffer || [];
        this._lmBuffer = [];
        if (!buffer.length) {
          this._maybeCacheRemainder(); // nothing to paint — but the run may just have completed (see stop)
          return 0;
        }
        this._flushActive = true;
        var self = this;
        // Numeric-aware sort so codes/positions read like the chart ("99" before "216", "51" before "100").
        buffer.sort(function (a, b) {
          return self.compareSortKey(a.key, b.key);
        });

        // Snapshot of the remainder tiles already in the grid (sorted — every earlier flush inserted in
        // order). exIdx only ever moves forward: the buffer is sorted too, so each entry's insertion point
        // is at or after the previous one's.
        var existing = Array.prototype.slice.call(this.grid.querySelectorAll('.karin-swatch--more'));
        var exIdx = 0;

        var CHUNK = 12;                 // cards are heavy (a panel + a form per size) → bound each frame's work
        var idx = 0;
        var added = [];
        var baseCount = this.items ? this.items.length : 0;
        var raf =
          window.requestAnimationFrame
            ? window.requestAnimationFrame.bind(window)
            : function (cb) {
                return setTimeout(cb, 16);
              };

        // Insert one colour (swatch + its panel) before the first existing remainder tile that sorts after
        // it — or at the very end when none does. Inserting before the SWATCH keeps every pair adjacent.
        function insertEntry(entry) {
          while (
            exIdx < existing.length &&
            self.compareSortKey(existing[exIdx].getAttribute('data-sort-key') || '', entry.key) <= 0
          ) {
            exIdx++;
          }
          var ref = exIdx < existing.length ? existing[exIdx] : null;
          if (ref) {
            self.grid.insertBefore(entry.swatch, ref);
            if (entry.panel) self.grid.insertBefore(entry.panel, ref);
          } else {
            self.grid.appendChild(entry.swatch);
            if (entry.panel) self.grid.appendChild(entry.panel);
          }
        }

        function paintChunk() {
          var chunk = [];
          var end = Math.min(idx + CHUNK, buffer.length);
          for (; idx < end; idx++) {
            insertEntry(buffer[idx]);
            chunk.push(buffer[idx].swatch);
            added.push(buffer[idx].swatch);
          }
          // Start THIS chunk's images loading right away so pictures stream in with their tiles.
          self.observeSecondSwatchTiles(chunk);
          // Grow the visible count as chunks land (a filter, if active, recomputes it in the finalise step).
          if (!self.isFiltering()) self.updateCount(baseCount + added.length);

          if (idx < buffer.length) {
            raf(paintChunk); // yield a frame so the browser paints and stays responsive between chunks
          } else {
            // All chunks in — finalise: cached tile list (document order for panel placement) + facets +
            // any active filter/count.
            self.items = Array.prototype.slice.call(self.grid.querySelectorAll('.karin-swatch'));
            self.growFacets(added);
            if (self.isFiltering()) {
              self.applyFilters();
            } else {
              self.updateCount(self.items.length);
            }
            // Pre-resolve the freshly-landed tiles' 2nd images in the background too, so scrolling through
            // the remainder is as instant as the curated block (near-viewport tiles were already handled by
            // the per-chunk observeSecondSwatchTiles above).
            self.warmSecondSwatchImages();
            // A cache-hydrated remainder was serialized on a DIFFERENT product page with its per-product
            // state stripped — now that its tiles are all in the DOM, re-mark this page's current colour.
            if (self._rmFromCache && !self._rmMarksApplied) {
              self._rmMarksApplied = true;
              self._applyCurrentMarks();
            }
            self._flushActive = false;
            if (self._flushPending || (self._lmBuffer && self._lmBuffer.length)) {
              // A page landed while this flush painted — drain it now (with a fresh merge snapshot).
              self._flushPending = false;
              self.flushRemainder();
            } else {
              self._maybeCacheRemainder(); // possibly the last flush of the run → try the range cache write
            }
          }
        }

        paintChunk(); // first chunk paints synchronously → colours appear the moment a page lands
        return buffer.length;
      }

      // Natural, numeric-aware compare so paint codes sort like the chart: "216" after "99", "14 480"
      // after "14 350" — not lexically. Returns <0 / 0 / >0 like String.localeCompare.
      compareSortKey(a, b) {
        // Cache one Collator per instance: localeCompare-with-options builds a fresh collator on EVERY call.
        // Same locale (undefined → default) + same options → CompareStrings is identical per ECMA-402, so
        // ordering is byte-identical. Fall back to localeCompare where Intl.Collator is unavailable.
        var c = this._sortCollator;
        if (c === undefined) {
          c = this._sortCollator =
            typeof Intl !== 'undefined' && Intl.Collator
              ? new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
              : null;
        }
        return c
          ? c.compare(String(a), String(b))
          : String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
      }

      // ----- Per-range remainder session cache -----
      // The remainder is identical for EVERY product of a range (its per-product bits — is-current marks,
      // open panels, filter state — are stripped before storing and re-derived on hydrate), and discovering
      // it costs the store-wide metaobject scan, the most expensive render this theme does. So once a run
      // completes, the sorted remainder HTML is cached in sessionStorage keyed by the RANGE: browsing to any
      // other colour/size of the same range then hydrates it instantly — zero fetches (see initLoadMore).

      // Cache key. Locale + currency are baked into the cached HTML (URLs, money), so they're part of the
      // key; the version tag lets a future markup change invalidate stale entries.
      _rmCacheKey() {
        var range = this.lmWrap && this.lmWrap.getAttribute('data-range-handle');
        if (!range) return null;
        var locale = (window.Shopify && window.Shopify.locale) || '';
        var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
        return 'karin:rm:v1:' + range + ':' + locale + ':' + currency;
      }

      // Write the cache once the WHOLE run is done: every page walked (_lmExhausted), nothing still painting
      // (_flushActive) or waiting to paint. An empty remainder is stored as '' on purpose — a range with
      // exactly 50 colours then skips the discovery fetch on every later page this session. Never writes in
      // the theme editor (merchants must see fresh data) or when this grid itself came from the cache.
      _maybeCacheRemainder() {
        if (this._rmFromCache || this._rmCacheWritten) return;
        if (!this._lmExhausted || this._flushActive || this._flushPending) return;
        if (this._lmBuffer && this._lmBuffer.length) return;

        // COMPLETENESS ALARM (console only — no markup, no UI, no behaviour change).
        // The range metaobject knows its TRUE colour count (data-expected-total, uncapped). A run that has
        // walked every page and still rendered fewer tiles than that means some colours are UNREACHABLE,
        // and there are only a few ways that happens: they are missing from the range's `colour_handles`;
        // or they have no size product, so no membership signal can see them; or the storefront locale
        // translates their product handles away from the range handle's words (a Turkish range handle finds
        // nothing under /en, where "akrilik" renders as "acrylic"). Each of those is invisible otherwise —
        // the chart just quietly shows fewer colours than the merchant authored. Deliberately placed BEFORE
        // the _lmHadFailure / designMode returns, so a skipped page also reports.
        if (!this._rmWarned) {
          this._rmWarned = true;
          var expected = parseInt((this.lmWrap && this.lmWrap.getAttribute('data-expected-total')) || '0', 10);
          var shown = this.items ? this.items.length : 0;
          if (expected > 0 && shown < expected && window.console && console.warn) {
            var rangeName = (this.lmWrap && this.lmWrap.getAttribute('data-range-handle')) || '?';
            console.warn(
              '[karin] paint range "' + rangeName + '": rendered ' + shown + ' of ' + expected +
              ' colours — ' + (expected - shown) + ' unreachable. Add their handles to the range\'s ' +
              'colour_handles metafield (the only locale-proof source; Liquid cannot read a list field ' +
              'past its 50th entry).'
            );
          }
        }

        if (this._lmHadFailure) return; // a page was skipped — caching would freeze an incomplete remainder
        if (window.Shopify && window.Shopify.designMode) return;
        var key = this._rmCacheKey();
        if (!key) return;
        this._rmCacheWritten = true; // one attempt per page view, success or fail
        var html = this._serializeRemainder();
        if (html === null) return; // over the size guard — better no cache than a truncated one
        try {
          sessionStorage.setItem(key, html);
        } catch (e) {
          // Quota hit: make room by dropping OTHER ranges' remainder caches and retry once; if it still
          // fails (tiny quota / private mode), give up quietly — everything works without the cache.
          try {
            for (var i = sessionStorage.length - 1; i >= 0; i--) {
              var k = sessionStorage.key(i);
              if (k && k.indexOf('karin:rm:') === 0 && k !== key) sessionStorage.removeItem(k);
            }
            sessionStorage.setItem(key, html);
          } catch (e2) {}
        }
      }

      // Serialize the loaded remainder (every .karin-swatch--more tile + its panel, in on-screen sorted
      // order) with per-product / transient state stripped, so the HTML is valid on ANY product page of the
      // range: no is-current / data-current / is-open / karin-flash, no filter-hidden attributes, panels
      // closed with their positioning styles cleared. Returns null when the payload would risk blowing the
      // sessionStorage quota (~5MB) — huge ranges just keep the normal fetch path.
      _serializeRemainder() {
        if (!this.grid) return '';
        var tiles = this.grid.querySelectorAll('.karin-swatch--more');
        var parts = [];
        for (var i = 0; i < tiles.length; i++) {
          var tile = tiles[i];
          var panelId = tile.getAttribute('aria-controls');
          var panel = panelId ? document.getElementById(panelId) : null;
          var t = tile.cloneNode(true);
          t.classList.remove('is-current', 'is-open');
          t.removeAttribute('data-current');
          t.removeAttribute('aria-current'); // was for the product this cache was serialized on — re-derived on hydrate
          t.removeAttribute('hidden');
          t.setAttribute('aria-expanded', 'false');
          parts.push(t.outerHTML);
          if (panel) {
            var p = panel.cloneNode(true);
            p.setAttribute('hidden', '');
            p.removeAttribute('style');
            var rows = p.querySelectorAll('.karin-row');
            for (var r = 0; r < rows.length; r++) {
              rows[r].classList.remove('is-current', 'karin-flash');
              rows[r].removeAttribute('hidden');
            }
            parts.push(p.outerHTML);
          }
        }
        var html = parts.join('');
        if (html.length > 1500000) return null; // ~3MB as UTF-16 — leave room for the rest of the session
        return html;
      }

      // A hydrated remainder carries no is-current state (it was serialized on a different product page).
      // Re-derive it for THIS page: size rows carry data-size-id, so the remainder tile whose panel contains
      // this product's row is the current colour — mark the row, the tile and data-current (which openCurrent
      // and the ring styling key off). No-op when the current colour is curated (the usual case).
      _applyCurrentMarks() {
        var pid = this.lmWrap && this.lmWrap.getAttribute('data-product-id');
        if (!pid || !this.grid) return;
        var tiles = this.grid.querySelectorAll('.karin-swatch--more');
        for (var i = 0; i < tiles.length; i++) {
          var panelId = tiles[i].getAttribute('aria-controls');
          var panel = panelId ? document.getElementById(panelId) : null;
          if (!panel) continue;
          var row = panel.querySelector('.karin-row[data-size-id="' + pid + '"]');
          if (!row) continue;
          row.classList.add('is-current');
          tiles[i].classList.add('is-current');
          tiles[i].setAttribute('data-current', 'true');
          tiles[i].setAttribute('aria-current', 'true');
          break;
        }
      }

      // After a Load More batch, make the facet UI reflect the newly shown colours: add any not-yet-listed
      // Colour-family and Size options to their dropdowns, and extend the search-suggestion index with the
      // new colours' names + codes. Filtering/count already work (tiles are in this.items); this keeps the
      // dropdowns + autocomplete complete too. Missing selects/index are handled gracefully (no-ops).
      growFacets(swatches) {
        if (!swatches || !swatches.length) return;
        var familySel = null;
        var sizeSel = null;
        for (var i = 0; i < this.filters.length; i++) {
          var k = this.filters[i].getAttribute('data-karin-filter');
          if (k === 'family') familySel = this.filters[i];
          else if (k === 'size') sizeSel = this.filters[i];
        }
        var tColour = (this.lmWrap && this.lmWrap.getAttribute('data-t-colour')) || 'Colour';
        var tCode = (this.lmWrap && this.lmWrap.getAttribute('data-t-code')) || 'Code';

        function hasOption(sel, val) {
          for (var o = 0; o < sel.options.length; o++) {
            if (sel.options[o].value === val) return true;
          }
          return false;
        }
        function addOption(sel, val, label) {
          if (!sel || !val || hasOption(sel, val)) return false;
          var opt = document.createElement('option');
          opt.value = val;
          opt.textContent = label || val;
          sel.appendChild(opt);
          return true;
        }
        // Re-sort a select's options alphabetically by label, keeping the leading "all" option first.
        function sortSelect(sel) {
          if (!sel) return;
          var opts = Array.prototype.slice.call(sel.options);
          opts.shift(); // leave the "all" option pinned at the top
          opts.sort(function (a, b) {
            return a.textContent.localeCompare(b.textContent);
          });
          for (var n = 0; n < opts.length; n++) sel.appendChild(opts[n]); // appendChild MOVES into order
        }

        var famChanged = false;
        var sizeChanged = false;
        for (var s = 0; s < swatches.length; s++) {
          var sw = swatches[s];
          if (familySel) {
            var fv = sw.getAttribute('data-family') || '';
            var fl = sw.getAttribute('data-family-label') || fv;
            if (fv && addOption(familySel, fv, fl)) famChanged = true;
          }
          var pid = sw.getAttribute('aria-controls');
          var panel = pid ? document.getElementById(pid) : null;
          if (this.index) {
            var nameEl = sw.querySelector('.karin-swatch__name');
            var cid = sw.getAttribute('data-colour-id');
            if (nameEl && cid) {
              this.index.push({ type: tColour, label: nameEl.textContent.trim(), kind: 'colour', id: cid });
            }
            if (panel && cid) {
              var codeCells = panel.querySelectorAll('.karin-row__code');
              for (var c = 0; c < codeCells.length; c++) {
                var code = codeCells[c].textContent.trim();
                if (code) this.index.push({ type: tCode, label: code, kind: 'colour', id: cid });
              }
            }
          }
          if (sizeSel && panel) {
            var rows = panel.querySelectorAll('.karin-row');
            for (var r = 0; r < rows.length; r++) {
              var sv = rows[r].getAttribute('data-size-label') || '';
              var slEl = rows[r].querySelector('.karin-row__sizelabel');
              var sl = slEl ? slEl.textContent.trim() : sv;
              if (sv && addOption(sizeSel, sv, sl)) sizeChanged = true;
            }
          }
        }
        if (famChanged) sortSelect(familySel);
        if (sizeChanged) sortSelect(sizeSel);
      }

      // The "More options" CTA lives outside this element (in the buy-buttons block). On click, first
      // reveal the content if it's gated until the CTA (hide-until-CTA mode — see revealFromCta), then
      // smooth-scroll to the on-page options grid. We target the inner app (the filter bar / grid) rather
      // than the section wrapper, so the section's own top padding isn't left as empty space above the
      // header line. The target is looked up live at click time so it always resolves the current section
      // (robust to theme-editor re-renders). Each button is wired once.
      wireMoreOptionsCta() {
        var self = this;
        var btns = document.querySelectorAll('[data-karin-scroll-to-options]');
        for (var i = 0; i < btns.length; i++) {
          if (btns[i]._karinWired) continue;
          btns[i]._karinWired = true;
          btns[i].addEventListener('click', function () {
            // In hide-until-CTA mode the palette / table is hidden on load; reveal it first so the scroll
            // lands on visible content. A no-op (leaving the scroll behaviour unchanged) when nothing
            // is gated — i.e. the setting is off, or it was already revealed by an earlier click.
            self.revealFromCta();
            var target = document.querySelector('.karin-pv__app') || document.querySelector('.karin-pv');
            if (!target) return;
            try {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } catch (e) {
              target.scrollIntoView();
            }
          });
        }
        // Safety net: if this section is set to hide until the CTA is clicked but there is no such CTA
        // on the page to reveal it (e.g. the buy-buttons block was removed), reveal it anyway so the
        // hidden palette / table can never become unreachable.
        if (this.hideUntilCta && btns.length === 0) {
          this.revealFromCta();
        }
      }

      // Reveal the content gated by hide-until-CTA. The filter bar is always visible; only the palette
      // (paints swatch grid) / products (brush table) are hidden — via that element's [hidden] attribute.
      // Returns early (leaving the CTA's scroll behaviour untouched) when nothing is gated: the setting is
      // off, or it was already revealed by an earlier click or a filter interaction. Because reveal just
      // clears hideTarget.hidden, it also lifts any hide-until-filter gate on the same element.
      revealFromCta() {
        if (!this.hideUntilCta || !this.hideTarget || this.gridRevealed) return;
        this.gridRevealed = true;
        this.hideTarget.hidden = false;
        this.revealLoadMore();
        // The current colour panel may have been auto-opened while its grid was hidden, so its pointer
        // triangle was measured against a zero-size box; recompute it now that the grid has real layout.
        this.repositionOpen();
      }

      // Show the price column's down-caret by default WITHOUT reordering the rows. `data-caret-only`
      // marks it indicator-only, so the first real click on price sorts in the shown direction (desc).
      showDefaultSortCaret() {
        var priceHeaders = this.querySelectorAll('[data-karin-sort="price"]');
        for (var i = 0; i < priceHeaders.length; i++) {
          priceHeaders[i].setAttribute('data-sort-dir', 'desc');
          priceHeaders[i].setAttribute('data-caret-only', 'true');
        }
      }

      // ----- "Second image of first linked product" swatch source -----
      // Active only when the section setting `swatch_image_source` is "second_product_image", which makes
      // karin-swatch-card stamp `data-karin-second-image="{handle}"` on each tile (and nothing on the default
      // "metaobject" source, so every method below is then a complete no-op).
      //
      // Why fetch client-side: a paint size product is a doubly-nested metaobject reference
      // (product -> paint_range -> colours -> sizes). Shopify does not hydrate a nested product's images
      // array in Liquid (only featured_image resolves), so the 2nd image is unknowable at render time. We
      // fetch each tile's /products/{handle}.js in the browser and swap the swatch <img> to images[1]. Work
      // is lazy (IntersectionObserver — a 50-250 tile grid only loads what nears the viewport) and cached
      // per handle so repeated / duplicate handles share one request.
      initSecondSwatchImages() {
        if (!this.grid) return;
        this._secondImageCache = Object.create(null); // handle -> URL | null | in-flight Promise
        if ('IntersectionObserver' in window) {
          var self = this;
          this._secondImageObserver = new IntersectionObserver(
            function (entries) {
              for (var i = 0; i < entries.length; i++) {
                if (!entries[i].isIntersecting) continue;
                var tile = entries[i].target;
                self._secondImageObserver.unobserve(tile);
                self.swapSecondSwatchImage(tile);
              }
            },
            // Preload well ahead of the viewport (~2 screens) so tiles fill in BEFORE they're scrolled into
            // view — the grid reads as "already loaded" instead of blank boxes popping in as you scroll. The
            // fetches are the tiny ?view= URL responses and stay off the main thread, so this stays smooth.
            { rootMargin: '1200px 0px' }
          );
        }
        this.observeSecondSwatchTiles(this.items);
        // Then pre-resolve the REST of the grid in the background (see warmSecondSwatchImages) — but START
        // it only AFTER the page has finished loading, so these tiny ?view= fetches never compete with the
        // page's critical resources. Behaviour is UNCHANGED: near-viewport tiles are still pre-filled
        // immediately by the observer above (~2 screens ahead), and the rest are still warmed in idle time
        // long before the visitor scrolls to them (no "blank box pop-in"). Only the START moment moved.
        var self = this;
        var startWarm = function () {
          if (window.requestIdleCallback) {
            window.requestIdleCallback(function () { self.warmSecondSwatchImages(); }, { timeout: 2000 });
          } else {
            window.setTimeout(function () { self.warmSecondSwatchImages(); }, 300);
          }
        };
        if (document.readyState === 'complete') {
          startWarm();
        } else {
          this._onWarmLoad = startWarm;
          window.addEventListener('load', startWarm, { once: true });
        }
      }

      // BACKGROUND WARM-UP — resolve every tile's 2nd-image URL ahead of scroll. The observer above still
      // serves near-viewport tiles first (it fires immediately for them); this queue then works through the
      // rest of the grid during idle time, a few tiny ?view= fetches at a time. By the time the visitor
      // scrolls, the swap is already done — tiles no longer visibly fill in as you watch. Cheap by design:
      // each fetch is a few dozen bytes (cached in sessionStorage across product pages), and the actual image
      // BYTES still ride the <img loading="lazy">, so there is no image-download storm. Skipped entirely for
      // visitors who asked for reduced data (Save-Data) — they keep the pure near-viewport behaviour.
      warmSecondSwatchImages() {
        if (!this.grid) return;
        var conn = navigator.connection;
        if (conn && conn.saveData) return;
        if (!this._warmQueue) this._warmQueue = [];
        var tiles = this.grid.querySelectorAll('.karin-swatch[data-karin-second-image]');
        for (var i = 0; i < tiles.length; i++) {
          var tile = tiles[i];
          if (tile._secondImageDone || tile._secondImageWarmQueued) continue;
          tile._secondImageWarmQueued = true;
          this._warmQueue.push(tile);
        }
        this._drainSecondImageWarmup();
      }

      // Drain the warm-up queue with a small fixed concurrency, yielding to idle time between items so the
      // warm-up never competes with user interaction or page-critical work. Re-entrant safe: while a drain is
      // running, warmSecondSwatchImages just appends to the same queue (e.g. the Load-More remainder landing).
      _drainSecondImageWarmup() {
        if (this._warmRunning) return;
        if (!this._warmQueue || !this._warmQueue.length) return;
        var self = this;
        var WORKERS = 4;
        var idle = window.requestIdleCallback
          ? function (cb) {
              window.requestIdleCallback(cb, { timeout: 500 });
            }
          : function (cb) {
              setTimeout(cb, 150);
            };

        function next() {
          var tile = self._warmQueue.shift();
          if (!tile) {
            self._warmActive--;
            if (self._warmActive <= 0) self._warmRunning = false;
            return;
          }
          // swapSecondSwatchImage guards per-tile (a tile the observer already handled is a no-op) and
          // resolves whether the fetch succeeded or not — either way, move on to the next tile in idle time.
          Promise.resolve(self.swapSecondSwatchImage(tile)).then(
            function () {
              idle(next);
            },
            function () {
              idle(next);
            }
          );
        }

        this._warmRunning = true;
        this._warmActive = WORKERS;
        for (var w = 0; w < WORKERS; w++) idle(next);
      }

      // Watch a set of tiles — the initial grid, then each "Load more" batch. Tiles without the attribute
      // (i.e. the default source) are skipped, and each tile is only ever queued once.
      observeSecondSwatchTiles(tiles) {
        if (!tiles || !this.grid) return;
        for (var i = 0; i < tiles.length; i++) {
          var tile = tiles[i];
          if (!tile || !tile.getAttribute || !tile.getAttribute('data-karin-second-image')) continue;
          if (tile._secondImageQueued) continue;
          tile._secondImageQueued = true;
          if (this._secondImageObserver) {
            this._secondImageObserver.observe(tile);
          } else {
            this.swapSecondSwatchImage(tile); // no IntersectionObserver support: fetch right away
          }
        }
      }

      // Resolve a product handle's 2nd image URL, or null when there isn't one. Cached per handle (in memory
      // + per-session), and concurrent callers share one in-flight request. Shared by the grid tiles
      // (swapSecondSwatchImage) and the colour panels (resolvePanelSecondImage).
      //
      // SPEED: a nested product's 2nd image can't be resolved in Liquid at grid-render time, so it's fetched
      // here. We hit a tiny alternate template (?view=karin-swatch-img) that prints ONLY the image URL (a few
      // dozen bytes) instead of downloading the entire product via /products/{handle}.js. If that view isn't
      // present/valid on the store, we fall back to .js, so behaviour is identical — just slower without it.
      fetchSecondImage(handle, url) {
        if (!this._secondImageCache) this._secondImageCache = Object.create(null);
        var cached = this._secondImageCache[handle];
        if (cached !== undefined) {
          return cached && typeof cached.then === 'function' ? cached : Promise.resolve(cached);
        }
        // Warm from the per-session store first (instant, no request) so paging between products doesn't refetch.
        var stored = this._readSecondImageStore(handle);
        if (stored !== undefined) {
          this._secondImageCache[handle] = stored;
          return Promise.resolve(stored);
        }
        var self = this;
        var request = this._resolveSecondImageUrl(handle, url)
          .then(function (url) {
            self._secondImageCache[handle] = url; // cache the URL, or null when there is no usable 2nd image
            self._writeSecondImageStore(handle, url);
            return url;
          })
          .catch(function () {
            self._secondImageCache[handle] = null;
            return null;
          });
        this._secondImageCache[handle] = request; // cache the in-flight promise so duplicate handles share it
        return request;
      }

      // Storefront path for a handle (respects a locale/shop root prefix), no trailing query.
      _productPath(handle) {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (root.charAt(root.length - 1) !== '/') root += '/';
        return root + 'products/' + encodeURIComponent(handle);
      }

      // LOCALE-SAFE product base for the 2nd-image fetch: prefer the Liquid-emitted product URL (correct
      // locale prefix AND locale-translated handle), stripped of any query/hash; fall back to rebuilding from
      // handle + routes.root. Rebuilding mismatches when a product's handle is translated per locale
      // (…-oil-paint-… vs …-yagli-boya-…), making ?view=/.js 404 or redirect on one locale so the swatch
      // image never resolves there. The result (a CDN image URL) is locale-independent, so it's still cached
      // by handle and shared across locales/surfaces.
      _secondImageBase(handle, url) {
        if (url) return url.split('#')[0].split('?')[0];
        return this._productPath(handle);
      }

      // Lean resolve: the tiny ?view= template returns just the URL (or the literal "none"). Falls back to the
      // full product JSON when that view is missing/invalid (a missing view renders the full product page —
      // detected here by the presence of "<" — so we never mistake an HTML page for an image URL).
      _resolveSecondImageUrl(handle, url) {
        var self = this;
        var base = this._secondImageBase(handle, url);
        return fetch(base + '?view=karin-swatch-img', { headers: { Accept: 'text/html' } })
          .then(function (r) {
            return r.ok ? r.text() : '';
          })
          .then(function (body) {
            var text = (body || '').trim();
            if (text === 'none') return null; // the view ran and this product genuinely has no 2nd image
            if (text && text.indexOf('<') === -1 && text.length < 2000 && /(^https?:|^\/\/)/.test(text)) {
              return text;
            }
            return self._fetchSecondImageFromProductJs(handle, url); // view absent/invalid → original behaviour
          })
          .catch(function () {
            return self._fetchSecondImageFromProductJs(handle, url);
          });
      }

      // Original path, kept as the fallback: download the whole product and read images[1].
      _fetchSecondImageFromProductJs(handle, url) {
        return fetch(this._secondImageBase(handle, url) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .then(function (data) {
            // /products/{handle}.js returns `images` as an ordered array of URLs; [1] is the 2nd image.
            var images = (data && data.images) || [];
            return images.length > 1 ? images[1] : null;
          });
      }

      // Per-session cache (survives navigation between products in the same tab). undefined = not stored,
      // null = stored as "no 2nd image", else the URL. Guarded — sessionStorage can throw (private mode/quota).
      _readSecondImageStore(handle) {
        try {
          var v = sessionStorage.getItem('karin:2img:' + handle);
          if (v === null) return undefined;
          return v === '' ? null : v;
        } catch (e) {
          return undefined;
        }
      }
      _writeSecondImageStore(handle, url) {
        try {
          sessionStorage.setItem('karin:2img:' + handle, url == null ? '' : url);
        } catch (e) {}
      }

      // Grid tile: fill its swatch <img> with the linked product's 2nd image. The tile is rendered EMPTY for
      // this source (no 1st/featured image), so this is the first and only image it shows — no flash. When the
      // product has no 2nd image, fall back to the tile's stashed featured/swatch image so it isn't left blank.
      // One attempt per tile, success or fail. Returns the swap promise so the background warm-up queue can
      // pace itself on completion (callers that ignore it are unaffected).
      swapSecondSwatchImage(tile) {
        if (!tile || tile._secondImageDone) return;
        tile._secondImageDone = true;
        var handle = tile.getAttribute('data-karin-second-image');
        if (!handle) return;
        var purl = tile.getAttribute('data-karin-second-image-url') || '';
        var self = this;
        return this.fetchSecondImage(handle, purl).then(function (url) {
          if (url) self.setSwatchImage(tile, url);
          else self.showSwatchFallback(tile);
        });
      }

      // Get the tile's swatch <img>, creating it (replacing the placeholder) if the tile rendered empty.
      ensureSwatchImg(tile) {
        var media = tile.querySelector('.karin-swatch__media');
        if (!media) return null;
        var img = media.querySelector('.karin-swatch__img');
        if (img) return img;
        var placeholder = media.querySelector('.karin-swatch__placeholder');
        if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
        var nameEl = tile.querySelector('.karin-swatch__name');
        img = document.createElement('img');
        img.className = 'karin-swatch__img';
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
        img.setAttribute('alt', nameEl ? nameEl.textContent : '');
        media.appendChild(img);
        return img;
      }

      // Point the tile's swatch <img> at `rawUrl` with a responsive srcset (used for the resolved 2nd image).
      setSwatchImage(tile, rawUrl) {
        var img = this.ensureSwatchImg(tile);
        if (!img) return;
        img.setAttribute(
          'srcset',
          this.cdnImage(rawUrl, 200) + ' 200w, ' + this.cdnImage(rawUrl, 400) + ' 400w, ' + this.cdnImage(rawUrl, 600) + ' 600w'
        );
        img.setAttribute('sizes', '(min-width: 990px) 16rem, 45vw');
        img.src = this.cdnImage(rawUrl, 400);
      }

      // No 2nd image for this tile: show the stashed fallback (the product's featured image, else the metaobject
      // swatch) so the tile isn't left blank. The 1st image only ever appears here — never as a pre-swap flash.
      showSwatchFallback(tile) {
        var url = tile.getAttribute('data-karin-fallback');
        if (!url) return; // nothing to fall back to — leave the placeholder in place
        var img = this.ensureSwatchImg(tile);
        if (!img) return;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = url;
      }

      // Append a Shopify CDN width param to a /products/{handle}.js image URL (which is protocol-relative).
      cdnImage(url, width) {
        if (!url) return url;
        var absolute = url.indexOf('//') === 0 ? 'https:' + url : url;
        // The lean ?view= endpoint returns a URL that already carries a width= param; strip any existing one
        // so requested widths never stack into "?width=600&width=400". No-op for /products/{handle}.js URLs,
        // which carry no width param — so the fallback path is byte-for-byte unchanged.
        absolute = absolute
          .replace(/([?&])width=\d+/gi, '$1')
          .replace(/&{2,}/g, '&')
          .replace(/\?&/g, '?')
          .replace(/[?&]$/g, '');
        return absolute + (absolute.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
      }

      // Colour panel (on open): resolve the "second image of first linked product" for its swatch thumbnail.
      // The thumbnail is emitted hidden with an empty <img> and empty data-full/data-zoom; here we fill those
      // from the product's 2nd image and reveal it, or remove the thumbnail when the product has no 2nd image.
      // Reuses the per-handle cache the grid tiles populate. No-op for the default "metaobject" source (no such
      // thumbnail is emitted). Panels are hidden until opened, so this runs on open rather than via the observer.
      resolvePanelSecondImage(panel) {
        if (!panel) return;
        var thumb = panel.querySelector('[data-karin-swatch-thumb][data-karin-second-image]');
        if (!thumb || thumb._secondImageDone) return;
        thumb._secondImageDone = true;
        var handle = thumb.getAttribute('data-karin-second-image');
        var purl = thumb.getAttribute('data-karin-second-image-url') || '';
        var self = this;
        if (!handle) {
          this.removePanelThumb(thumb);
          return;
        }
        this.fetchSecondImage(handle, purl).then(function (url) {
          if (!url) {
            self.removePanelThumb(thumb); // no 2nd image → drop the placeholder thumbnail entirely
            return;
          }
          var img = thumb.querySelector('img');
          if (img) {
            img.setAttribute('srcset', self.cdnImage(url, 60) + ' 60w, ' + self.cdnImage(url, 120) + ' 120w');
            img.setAttribute('sizes', '70px');
            img.src = self.cdnImage(url, 120);
          }
          thumb.setAttribute('data-full', self.cdnImage(url, 600));
          thumb.setAttribute('data-zoom', self.cdnImage(url, 1946));
          // Drop the marker so syncPanelMedia (size filtering) now treats it as a normal, resolved thumbnail.
          thumb.removeAttribute('data-karin-second-image');
          thumb.hidden = false;
        });
      }

      // Remove a panel thumbnail entirely (used when a "second image" thumb has no image to show).
      removePanelThumb(thumb) {
        if (thumb && thumb.parentNode) thumb.parentNode.removeChild(thumb);
      }

      disconnectedCallback() {
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        if (this._secondImageObserver) {
          this._secondImageObserver.disconnect();
          this._secondImageObserver = null;
        }
        // Empty the warm-up queue so its idle workers drain out and stop fetching for a detached grid.
        if (this._warmQueue) this._warmQueue = [];
        // Drop the deferred warm-up 'load' listener if it never fired, so it can't run on a detached grid.
        if (this._onWarmLoad) {
          window.removeEventListener('load', this._onWarmLoad);
          this._onWarmLoad = null;
        }
        // Tear down the load-more triggers (scroll observer + button click handler), so a disconnect→reconnect
        // (theme-editor reorder / DOM move) doesn't leave a stale observer watching a detached loader or a
        // duplicate click listener.
        if (this._lmObserver) {
          this._lmObserver.disconnect();
          this._lmObserver = null;
        }
        if (this._onLoadMore && this.lmBtn) {
          this.lmBtn.removeEventListener('click', this._onLoadMore);
          this._onLoadMore = null;
        }
        if (this._onCartError) document.removeEventListener('product-ajax:error', this._onCartError);
        if (this._onCartAdded) document.removeEventListener('product-ajax:added', this._onCartAdded);
        if (this._releaseScroll) this._releaseScroll();
        if (this._onLbKeydown) {
          document.removeEventListener('keydown', this._onLbKeydown);
          this._onLbKeydown = null;
        }
        document.documentElement.classList.remove('karin-lb-open');
        if (this._modal) {
          if (this._onModalClick) this._modal.removeEventListener('click', this._onModalClick);
          if (this._lbMain) {
            if (this._lbDown) this._lbMain.removeEventListener('pointerdown', this._lbDown);
            if (this._lbMove) this._lbMain.removeEventListener('pointermove', this._lbMove);
            if (this._lbUp) {
              this._lbMain.removeEventListener('pointerup', this._lbUp);
              this._lbMain.removeEventListener('pointercancel', this._lbUp);
            }
            if (this._lbWheel) this._lbMain.removeEventListener('wheel', this._lbWheel);
          }
          if (this._modal.parentNode) this._modal.parentNode.removeChild(this._modal);
        }
        this._modal = null;
      }

      onSubmit(e) {
        var form = e.target && e.target.closest ? e.target.closest('.karin-atc') : null;
        if (!form || !this.contains(form)) return;
        // No preventDefault: the theme's product-form adds to cart exactly as it normally does.
        this.activeForm = form;
        this.errorArmed = true;
        this.toggleAtcError(form, false);
        this.patchModalFocus();
        this.preserveScroll();
      }

      // Root-cause fix for the page jumping to the top: the cart drawer opens by focusing an element
      // (its close button / the first line item) through FoxTheme.a11y.trapFocus, which calls .focus()
      // WITHOUT `preventScroll`, so the browser scrolls that element into view. We replace trapFocus once
      // with a byte-for-byte copy of the theme's implementation whose every .focus() passes
      // `preventScroll: true`. Focus trapping is unchanged; the page simply stops moving. Patched globally,
      // only once. Called lazily (also on submit) so FoxTheme is guaranteed to have initialised.
      patchModalFocus() {
        var a11y = window.FoxTheme && window.FoxTheme.a11y;
        if (!a11y || typeof a11y.trapFocus !== 'function' || a11y.__karinNoScroll) return;
        a11y.__karinNoScroll = true;
        a11y.trapFocus = function (container, elementToFocus) {
          if (elementToFocus === undefined) elementToFocus = container;
          var elements = a11y.getFocusableElements(container);
          var first = elements[0];
          var last = elements[elements.length - 1];

          a11y.removeTrapFocus();

          a11y.trapFocusHandlers.focusin = function (event) {
            if (event.target !== container && event.target !== last && event.target !== first) return;
            document.addEventListener('keydown', a11y.trapFocusHandlers.keydown);
          };
          a11y.trapFocusHandlers.focusout = function () {
            document.removeEventListener('keydown', a11y.trapFocusHandlers.keydown);
          };
          a11y.trapFocusHandlers.keydown = function (event) {
            if (event.code.toUpperCase() !== 'TAB') return;
            if (event.target === last && !event.shiftKey) {
              event.preventDefault();
              first.focus({ preventScroll: true });
            }
            if ((event.target === container || event.target === first) && event.shiftKey) {
              event.preventDefault();
              last.focus({ preventScroll: true });
            }
          };

          document.addEventListener('focusout', a11y.trapFocusHandlers.focusout);
          document.addEventListener('focusin', a11y.trapFocusHandlers.focusin);

          if (elementToFocus && typeof elementToFocus.focus === 'function') {
            elementToFocus.focus({ preventScroll: true });
            if (
              elementToFocus.tagName === 'INPUT' &&
              ['search', 'text', 'email', 'url'].indexOf(elementToFocus.type) !== -1 &&
              elementToFocus.value
            ) {
              elementToFocus.setSelectionRange(0, elementToFocus.value.length);
            }
          }
        };
      }

      // Fallback to patchModalFocus: re-pin the saved scroll position for the brief window in which the
      // drawer opens, then release — on the drawer finishing, on the first real scroll gesture, or after a
      // short timeout — so the page never feels locked.
      preserveScroll() {
        if (this._releaseScroll) this._releaseScroll();

        var self = this;
        var x = window.scrollX || window.pageXOffset || 0;
        var y = window.scrollY || window.pageYOffset || 0;
        var released = false;
        var timer;

        function restore() {
          if (released) return;
          if (window.scrollX !== x || window.scrollY !== y) window.scrollTo(x, y);
        }
        function onFocusIn(e) {
          if (e.target && e.target.closest && e.target.closest('cart-drawer, .drawer')) restore();
        }
        function release() {
          if (released) return;
          released = true;
          window.removeEventListener('scroll', restore, true);
          document.removeEventListener('focusin', onFocusIn, true);
          window.removeEventListener('wheel', release, { passive: true });
          window.removeEventListener('touchmove', release, { passive: true });
          window.removeEventListener('keydown', onKeydown, true);
          document.removeEventListener('drawer:handleAfterShow', onShown);
          clearTimeout(timer);
          if (self._releaseScroll === release) self._releaseScroll = null;
        }
        function onShown() {
          // Drawer finished opening; restore once more next frame, then stop holding.
          requestAnimationFrame(function () {
            restore();
            release();
          });
        }
        function onKeydown(e) {
          var k = e.key;
          if (
            k === 'ArrowUp' || k === 'ArrowDown' || k === 'PageUp' || k === 'PageDown' ||
            k === 'Home' || k === 'End' || k === ' ' || k === 'Spacebar'
          ) {
            release();
          }
        }

        // `scroll` (capture) catches whatever moves the page — focus, scrollIntoView — and pins it back
        // before paint. `focusin` covers the synchronous focus shift. Any genuine gesture releases the hold.
        window.addEventListener('scroll', restore, true);
        document.addEventListener('focusin', onFocusIn, true);
        window.addEventListener('wheel', release, { passive: true });
        window.addEventListener('touchmove', release, { passive: true });
        window.addEventListener('keydown', onKeydown, true);
        document.addEventListener('drawer:handleAfterShow', onShown);
        timer = setTimeout(release, 1500);
        this._releaseScroll = release;
      }

      onCartError() {
        if (!this.errorArmed || !this.activeForm) return;
        this.errorArmed = false;
        this.toggleAtcError(this.activeForm, true);
      }

      onCartAdded() {
        this.errorArmed = false;
        if (this.activeForm) this.toggleAtcError(this.activeForm, false);
      }

      // Show / hide the max-quantity notice on its own row inside the swatch/brush table.
      toggleAtcError(form, show) {
        var el = form.querySelector('[data-karin-atc-error]');
        if (el) el.hidden = !show;
      }

      applyFilters() {
        var q = ((this.searchInput && this.searchInput.value) || '').trim().toLowerCase();
        var filters = this.filters;
        var gridMode = !!this.grid;
        var visible = 0;
        this.items.forEach(function (item) {
          var show = true;
          for (var i = 0; i < filters.length; i++) {
            var key = filters[i].getAttribute('data-karin-filter');
            if (gridMode && key === 'size') continue; // size filters panel rows, not tiles
            var val = filters[i].value;
            if (!val || val === 'all') continue;
            var setAttr = item.getAttribute('data-' + key + '-set');
            if (setAttr !== null) {
              if (setAttr.indexOf('~~' + val + '~~') === -1) {
                show = false;
                break;
              }
            } else if ((item.getAttribute('data-' + key) || '') !== val) {
              show = false;
              break;
            }
          }
          if (show && q && (item.getAttribute('data-search') || '').indexOf(q) === -1) {
            show = false;
          }
          item.hidden = !show;
          if (show) visible++;
        });

        if (this.grid) {
          // Filter the open panel's rows IN PLACE. Do NOT move/reposition the panel while filtering —
          // moving the DOM node on every keystroke shifts everything below it and churns the page height.
          // Only close the panel if its own tile got filtered out.
          if (this.openTile && this.openTile.hidden) {
            this.closePanel(false);
          }
          this.applyRowFilters();
        }
        this.updateCount(visible);
        // Show the "no results" message (like the reference) only when nothing matches.
        if (this.emptyEl) this.emptyEl.hidden = visible !== 0;
        this.updateClear();
        // Optional: keep the whole swatch grid / brush table hidden until the visitor interacts with the
        // filter bar. Applying a filter/search reveals it; once revealed it stays shown. While still
        // hidden the "no results" message is suppressed too (there's nothing to say yet).
        if (this.hideTarget && this.hideUntilFilter) {
          if (this.isFiltering()) this.gridRevealed = true;
          this.hideTarget.hidden = !this.gridRevealed;
          if (!this.gridRevealed && this.emptyEl) this.emptyEl.hidden = true;
          if (this.gridRevealed) this.revealLoadMore();
        }
        // Panels stay CLOSED on load — the colour plate opens ONLY when the visitor clicks a swatch.
        // The current product's swatch is still marked with the is-current ring (server-rendered class);
        // only the auto-opening of its panel is disabled, per request. (openCurrent() is retained below but
        // no longer auto-invoked.)
      }

      // Panel row filter (paints): a size-row shows when it matches BOTH the Size dropdown AND the search query.
      // The search narrows rows by size_label/code — like the Size filter — while a colour-name match keeps all rows.
      applyRowFilters() {
        if (!this.grid) return;
        var val = 'all';
        for (var i = 0; i < this.filters.length; i++) {
          if (this.filters[i].getAttribute('data-karin-filter') === 'size') {
            val = this.filters[i].value || 'all';
            break;
          }
        }
        var q = ((this.searchInput && this.searchInput.value) || '').trim().toLowerCase();
        var panels = this.grid.querySelectorAll('.karin-panel');
        for (var p = 0; p < panels.length; p++) {
          var colourMatch = q && (panels[p].getAttribute('data-colour-name') || '').indexOf(q) !== -1;
          var rows = panels[p].querySelectorAll('.karin-row');
          var visibleRows = 0;
          // Size ids of the rows still shown — the images strip is narrowed to exactly these below.
          var visibleIds = {};
          for (var r = 0; r < rows.length; r++) {
            var sizeOk = val === 'all' || rows[r].getAttribute('data-size-label') === val;
            var qOk = !q || colourMatch || (rows[r].getAttribute('data-row-search') || '').indexOf(q) !== -1;
            var rowShown = sizeOk && qOk;
            rows[r].hidden = !rowShown;
            if (rowShown) {
              visibleRows++;
              var vsid = rows[r].getAttribute('data-size-id');
              if (vsid) visibleIds[vsid] = true;
            }
          }
          // Hide the whole size table when no size matches the active filters, so the bare
          // SIZE/CODE/SPEC/PRICE header never sits above an empty body.
          var wrap = panels[p].querySelector('.karin-table-wrap');
          if (wrap) wrap.hidden = visibleRows === 0;
          // Narrow the panel's images to the size(s) still visible after filtering. "Narrowed" means the
          // filter dropped at least one row (a Size selection OR a code/name search) — a colour-name match
          // or no active filter leaves every row visible, so the full image set is restored.
          var narrowed = visibleRows > 0 && visibleRows < rows.length;
          this.syncPanelMedia(panels[p], narrowed, visibleIds);
        }
      }

      // Map the colour panel's images to the size ROWS still visible after filtering: when the filter
      // narrows the rows — via the Size dropdown OR a code/size search — show ONLY those sizes' product
      // images (their thumbnails + promote the first to the main image); when the filter is cleared,
      // restore the full set. Thumbnails carry data-size-id matching the size rows' data-size-id, so the
      // image shown always belongs to the exact product variant(s) that match the applied filter.
      syncPanelMedia(panel, narrowed, visibleIds) {
        var thumbs = panel.querySelectorAll('[data-karin-thumb]');
        if (!thumbs.length) return;
        if (!narrowed) {
          // Only restore if this panel was previously narrowed — otherwise leave the server default as-is.
          if (!panel._mediaFiltered) return;
          panel._mediaFiltered = false;
          var firstThumb = null;
          for (var i = 0; i < thumbs.length; i++) {
            // An unresolved "second image" swatch thumb stays hidden until resolvePanelSecondImage fills it.
            if (thumbs[i].hasAttribute('data-karin-second-image')) continue;
            thumbs[i].hidden = false;
            if (!firstThumb) firstThumb = thumbs[i];
          }
          if (firstThumb) this.swapThumb(firstThumb);
          return;
        }
        panel._mediaFiltered = true;
        var firstVisible = null;
        var swatchThumb = null;
        for (var j = 0; j < thumbs.length; j++) {
          // The colour swatch isn't tied to a size — keep it visible through filtering so the
          // pure-colour reference image always stays in the strip.
          if (thumbs[j].hasAttribute('data-karin-swatch-thumb')) {
            // Leave an unresolved "second image" swatch thumb hidden; resolvePanelSecondImage reveals/removes it.
            if (thumbs[j].hasAttribute('data-karin-second-image')) continue;
            thumbs[j].hidden = false;
            swatchThumb = thumbs[j];
            continue;
          }
          var sid = thumbs[j].getAttribute('data-size-id');
          var match = sid !== null && !!visibleIds[sid];
          thumbs[j].hidden = !match;
          if (match && !firstVisible) firstVisible = thumbs[j];
        }
        // Promote the first matching size's photo to the main image + active thumbnail. If the matching
        // size(s) have no photo, fall back to the colour swatch so the main image never keeps showing a
        // now-hidden size's image.
        var promote = firstVisible || swatchThumb;
        if (promote) this.swapThumb(promote);
      }

      openCurrent() {
        if (!this.grid) return;
        var current = this.items.filter(function (t) {
          return t.getAttribute('data-current') === 'true';
        })[0];
        if (current && !current.hidden) this.openPanel(current, false);
      }

      isFiltering() {
        var active = false;
        this.filters.forEach(function (f) {
          if (f.value && f.value !== 'all') active = true;
        });
        if (this.searchInput && this.searchInput.value.trim() !== '') active = true;
        return active;
      }

      updateClear() {
        if (this.clearEl) this.clearEl.hidden = !this.isFiltering();
      }

      updateCount(n) {
        if (!this.countEl) return;
        var one = this.countEl.getAttribute('data-noun-one') || '';
        var other = this.countEl.getAttribute('data-noun-other') || '';
        this.countEl.textContent = n + ' ' + (n === 1 ? one : other);
      }

      onClick(e) {
        // Reveal the swatch grid / brush table on ANY click inside the filter bar (dropdowns, search,
        // empty space), when it's kept hidden until interaction. Doesn't return — click handling continues.
        if (this.hideUntilFilter && !this.gridRevealed && this.barEl && this.barEl.contains(e.target)) {
          this.gridRevealed = true;
          if (this.hideTarget) this.hideTarget.hidden = false;
          this.revealLoadMore();
        }
        var step = e.target.closest('[data-karin-qstep]');
        if (step) {
          e.preventDefault();
          this.stepQty(step);
          return;
        }
        var moreToggle = e.target.closest('[data-karin-more-toggle]');
        if (moreToggle) {
          this.toggleMore(moreToggle);
          return;
        }
        var sortBtn = e.target.closest('[data-karin-sort]');
        if (sortBtn) {
          this.sortColumn(sortBtn);
          return;
        }
        var thumb = e.target.closest('[data-karin-thumb]');
        if (thumb) {
          this.swapThumb(thumb);
          return;
        }
        var zoom = e.target.closest('[data-karin-zoom]');
        if (zoom) {
          e.preventDefault();
          var zoomPanel = zoom.closest('.karin-panel');
          if (zoomPanel) this.openLightbox(zoomPanel);
          return;
        }
        var brushZoom = e.target.closest('[data-karin-brush-zoom]');
        if (brushZoom) {
          e.preventDefault();
          this.openLightboxFromData(brushZoom);
          return;
        }
        if (e.target.closest('[data-karin-panel-close]')) {
          this.closePanel(true);
          return;
        }
        if (this.grid) {
          var tile = e.target.closest('.karin-swatch');
          if (tile && this.grid.contains(tile)) this.togglePanel(tile);
        }
      }

      // Spec "More Info / Less Info": the body sits before the toggle in the DOM, so showing it puts the
      // details above and the toggle below — no reordering needed. State on the button's aria-expanded.
      toggleMore(btn) {
        var wrap = btn.closest('[data-karin-more]');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (wrap) wrap.classList.toggle('is-open', !isOpen);
      }

      onKeydown(e) {
        if (e.key === 'Escape' && this.openTile && e.target.closest && e.target.closest('.karin-panel')) {
          e.preventDefault();
          this.closePanel(true);
          return;
        }
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var sortBtn = e.target.closest('[data-karin-sort]');
        if (sortBtn) {
          e.preventDefault();
          this.sortColumn(sortBtn);
        }
      }

      onChange(e) {
        var input = e.target.closest('[data-karin-qty] input');
        if (!input) return;
        var min = parseInt(input.getAttribute('min') || '1', 10);
        if (isNaN(min)) min = 1;
        var v = parseInt(input.value || '', 10);
        if (isNaN(v) || v < min) input.value = min;
        var form = input.closest('.karin-atc');
        if (form) this.toggleAtcError(form, false);
      }

      sortColumn(header, forceDir) {
        var table = header.closest('table');
        if (!table) return;
        var tbody = table.querySelector('tbody');
        if (!tbody) return;
        var key = header.getAttribute('data-karin-sort') || 'price';
        var type = header.getAttribute('data-sort-type') || 'text';
        // Direction: forced wins; else if this column only shows the default "indicator" caret
        // (data-caret-only — the price down-arrow), the first real click sorts in that shown direction
        // (descending); otherwise toggle (a freshly-clicked column starts ascending).
        var dir;
        if (forceDir) {
          dir = forceDir;
        } else if (header.getAttribute('data-caret-only') === 'true') {
          dir = header.getAttribute('data-sort-dir') || 'desc';
        } else {
          dir = header.getAttribute('data-sort-dir') === 'asc' ? 'desc' : 'asc';
        }

        function valOf(row) {
          // Sort by the row's dedicated attribute for this column (price/size/code/shape/series).
          if (key === 'price') return row.getAttribute('data-price') || '';
          // Paint rows use data-size-label ("40 ml"); brush rows use data-size.
          if (key === 'size') return row.getAttribute('data-size-label') || row.getAttribute('data-size') || '';
          return row.getAttribute('data-' + key) || '';
        }
        function sortBy(list, d) {
          return list.slice().sort(function (a, b) {
            var cmp;
            if (type === 'num') {
              var na = parseFloat(valOf(a));
              var nb = parseFloat(valOf(b));
              if (isNaN(na)) na = 0;
              if (isNaN(nb)) nb = 0;
              cmp = na - nb;
            } else {
              var sa = String(valOf(a)).toLowerCase();
              var sb = String(valOf(b)).toLowerCase();
              cmp = sa < sb ? -1 : sa > sb ? 1 : 0;
            }
            return d === 'asc' ? cmp : -cmp;
          });
        }
        function sameOrder(a, b) {
          for (var k = 0; k < a.length; k++) {
            if (a[k] !== b[k]) return false;
          }
          return true;
        }

        var current = Array.prototype.slice.call(tbody.querySelectorAll('tr'));
        var sorted = sortBy(current, dir);
        // On a manual click, guarantee a visible reorder: if this direction leaves the order unchanged
        // — common with two rows whose size/price/code rank identically, or a tie column like Spec —
        // reverse the current order so the rows still swap, while KEEPING the toggled direction so the
        // arrow alternates up/down on each click (the same up/down toggle Code already has).
        if (!forceDir && sameOrder(current, sorted)) {
          sorted = current.slice().reverse();
        }

        var heads = table.querySelectorAll('[data-karin-sort]');
        for (var i = 0; i < heads.length; i++) {
          heads[i].removeAttribute('data-sort-dir'); // only the active column shows its arrow
          heads[i].removeAttribute('data-caret-only'); // any real sort clears the default indicator
        }
        header.setAttribute('data-sort-dir', dir);
        sorted.forEach(function (r) {
          tbody.appendChild(r);
        });
        // Keep the gallery thumbnail strip in the same order as the rows we just (re)sorted, so the
        // images follow the variant order. Non-size images (the colour swatch) keep their tail spot.
        this.reorderThumbs(header.closest('.karin-panel'), sorted);
      }

      // Re-order the panel's thumbnail strip to match a list of (sorted) size rows, matched by
      // data-size-id. Thumbnails without a size id (the colour swatch) are pushed to the end, keeping
      // their existing relative position. Safe no-op for tables with no gallery (e.g. the brush table).
      reorderThumbs(panel, sortedRows) {
        if (!panel || !sortedRows) return;
        var wrap = panel.querySelector('.karin-panel__thumbs');
        if (!wrap) return;
        var byId = {};
        var extras = [];
        Array.prototype.slice.call(wrap.children).forEach(function (t) {
          var sid = t.getAttribute && t.getAttribute('data-size-id');
          if (sid) byId[sid] = t;
          else extras.push(t);
        });
        sortedRows.forEach(function (r) {
          var sid = r.getAttribute('data-size-id');
          if (sid && byId[sid]) wrap.appendChild(byId[sid]);
        });
        extras.forEach(function (t) {
          wrap.appendChild(t);
        });
        // The new top (first) row's image becomes the active one, so the big preview matches the new
        // order. Prefer the first visible size thumbnail; the colour swatch (no size id) is ignored.
        var first =
          wrap.querySelector('[data-karin-thumb][data-size-id]:not([hidden])') ||
          wrap.querySelector('[data-karin-thumb][data-size-id]');
        if (first) this.swapThumb(first);
      }

      // Hovering a size row swaps the panel's main image to that size's picture, mirroring a click on its
      // gallery thumbnail. Matches the row to its thumbnail by data-size-id (each paint size is its own
      // product with its own featured_image). Does nothing when that size has no thumbnail image.
      onRowHover(e) {
        // Rows only exist inside an OPEN panel; with none open there is nothing to preview, so skip the
        // per-mouseover closest() DOM walk entirely.
        if (!this.openTile) return;
        var row = e.target.closest('.karin-row[data-size-id]');
        if (!row) return;
        var panel = row.closest('.karin-panel');
        if (!panel) return;
        var sid = row.getAttribute('data-size-id');
        var thumb = panel.querySelector('[data-karin-thumb][data-size-id="' + sid + '"]');
        // Already showing this size, or no matching image — nothing to do.
        if (!thumb || thumb.classList.contains('is-active')) return;
        this.swapThumb(thumb);
      }

      swapThumb(thumb) {
        var panel = thumb.closest('.karin-panel');
        if (!panel) return;
        var main = panel.querySelector('.karin-panel__main img');
        var full = thumb.getAttribute('data-full');
        if (main && full) {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.setAttribute('src', full);
        }
        var thumbs = panel.querySelectorAll('[data-karin-thumb]');
        for (var i = 0; i < thumbs.length; i++) {
          var on = thumbs[i] === thumb;
          thumbs[i].classList.toggle('is-active', on);
          thumbs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        }
      }

      /* ----- Image popup (custom modal) -----
         A self-contained centred popup like the reference: dimmed page, white dialog, thumbnail column on
         the left (vertical scroll if many), and a slider on the right. Images live in a horizontal track
         that slides smoothly; switch via thumbnail CLICK, drag, swipe, scroll, or ←→ keys (no arrows).
         The markup is rendered in the section and moved to <body> on connect so it stacks above all. */
      collectImages(panel) {
        var out = [];
        // Only the thumbnails currently shown (the size filter may have narrowed them), so the zoom
        // popup mirrors the filtered view instead of re-introducing other sizes' images.
        var thumbs = Array.prototype.slice
          .call(panel.querySelectorAll('[data-karin-thumb]'))
          .filter(function (t) {
            return !t.hidden;
          });
        if (thumbs.length) {
          thumbs.forEach(function (t) {
            var img = t.querySelector('img');
            var small = (img && (img.currentSrc || img.src)) || t.getAttribute('data-full');
            out.push({
              thumb: small,
              full: t.getAttribute('data-zoom') || t.getAttribute('data-full') || small,
              label: t.getAttribute('aria-label') || '',
            });
          });
          return out;
        }
        var main = panel.querySelector('.karin-panel__main');
        var mainImg = main && main.querySelector('img');
        var mainSmall = mainImg && (mainImg.currentSrc || mainImg.src);
        var full = (main && main.getAttribute('data-zoom')) || mainSmall;
        if (full) out.push({ thumb: mainSmall || full, full: full, label: (mainImg && mainImg.alt) || '' });
        return out;
      }

      activeThumbIndex(panel) {
        // Index within the currently-shown thumbnails, to stay aligned with collectImages().
        var thumbs = Array.prototype.slice
          .call(panel.querySelectorAll('[data-karin-thumb]'))
          .filter(function (t) {
            return !t.hidden;
          });
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].classList.contains('is-active')) return i;
        }
        return 0;
      }

      // Paints: collect the open colour panel's thumbnails and start on the active one.
      openLightbox(panel) {
        if (!this._modal) return;
        this.lbImages = this.collectImages(panel);
        if (!this.lbImages.length) return;
        var index = this.activeThumbIndex(panel);
        if (index < 0 || index >= this.lbImages.length) index = 0;
        this.showLightbox(index);
      }

      // Brushes: each row's zoom button carries its own image list as JSON (thumb/full/label).
      openLightboxFromData(el) {
        if (!this._modal) return;
        var imgs;
        try {
          imgs = JSON.parse(el.getAttribute('data-karin-images') || '[]');
        } catch (e) {
          imgs = [];
        }
        var self = this;
        this.lbImages = (imgs || [])
          .map(function (i) {
            var full = i.full || i.thumb;
            // The small popup-thumbnail URL is derived from `full` (a narrower CDN width) rather than shipped
            // per row — halves the data-karin-images payload. Older markup that still carries i.thumb is honoured.
            return { thumb: i.thumb || self.cdnImage(full, 160), full: full, label: i.label || '' };
          })
          .filter(function (i) {
            return i.full;
          });
        if (!this.lbImages.length) return;
        this.showLightbox(0);
      }

      // Open the popup on `index`, assuming this.lbImages is already set (shared by paints + brushes).
      showLightbox(index) {
        this.renderModalThumbs(index);
        this.renderSlides();
        // Jump to the starting image instantly (no slide on open), then re-enable smooth sliding.
        var track = this._modal.querySelector('[data-karin-lb-track]');
        if (track) {
          track.style.transition = 'none';
          this.setModalImage(index);
          void track.offsetWidth;
          track.style.transition = '';
        } else {
          this.setModalImage(index);
        }

        this._lastFocus = document.activeElement;
        this._modal.hidden = false;
        document.documentElement.classList.add('karin-lb-open');

        if (!this._onLbKeydown) {
          this._onLbKeydown = this.onModalKeydown.bind(this);
          document.addEventListener('keydown', this._onLbKeydown);
        }
        var closeBtn = this._modal.querySelector('.karin-lightbox__close');
        if (closeBtn) closeBtn.focus();
      }

      renderModalThumbs(activeIndex) {
        var wrap = this._modal.querySelector('[data-karin-lb-thumbs]');
        if (!wrap) return;
        if (this.lbImages.length < 2) {
          wrap.innerHTML = '';
          wrap.hidden = true;
          return;
        }
        wrap.hidden = false;
        var html = '';
        for (var i = 0; i < this.lbImages.length; i++) {
          var label = this.lbImages[i].label || 'Image ' + (i + 1);
          html +=
            '<button type="button" class="karin-lightbox__thumb' +
            (i === activeIndex ? ' is-active' : '') +
            '" data-karin-lb-thumb data-idx="' +
            i +
            '" aria-pressed="' +
            (i === activeIndex ? 'true' : 'false') +
            '" aria-label="' +
            escapeHtml(label) +
            '"><img src="' +
            escapeHtml(this.lbImages[i].thumb) +
            '" alt="" loading="lazy" decoding="async"></button>';
        }
        wrap.innerHTML = html;
      }

      // Build one slide per image inside the track (all loaded so the slide is seamless).
      renderSlides() {
        var track = this._modal.querySelector('[data-karin-lb-track]');
        if (!track) return;
        var html = '';
        for (var i = 0; i < this.lbImages.length; i++) {
          html +=
            '<div class="karin-lightbox__slide"><img src="' +
            escapeHtml(this.lbImages[i].full) +
            '" alt="' +
            escapeHtml(this.lbImages[i].label || '') +
            '" decoding="async"></div>';
        }
        track.innerHTML = html;
      }

      // Slide the track to `index` (clamped). The CSS transition makes it smooth.
      setModalImage(index) {
        var n = this.lbImages.length;
        if (index < 0) index = 0;
        if (index > n - 1) index = n - 1;
        this.lbIndex = index;
        var track = this._modal.querySelector('[data-karin-lb-track]');
        if (track) track.style.transform = 'translateX(' + -index * 100 + '%)';
        var thumbs = this._modal.querySelectorAll('[data-karin-lb-thumb]');
        for (var i = 0; i < thumbs.length; i++) {
          var on = i === index;
          thumbs[i].classList.toggle('is-active', on);
          thumbs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        }
      }

      onModalClick(e) {
        if (e.target.closest('[data-karin-lb-close]')) {
          this.closeLightbox();
          return;
        }
        var thumb = e.target.closest('[data-karin-lb-thumb]');
        if (thumb) {
          this.setModalImage(parseInt(thumb.getAttribute('data-idx'), 10) || 0);
        }
      }

      // Drag (mouse) / swipe (touch): the track follows the finger, then snaps on release.
      onLbPointerDown(e) {
        if (!this.lbImages || this.lbImages.length < 2) return;
        this._dragX = e.clientX;
        this._dragY = e.clientY;
        this._dragging = true;
        this._mainW = (this._lbMain && this._lbMain.getBoundingClientRect().width) || 1;
        this._track = this._modal.querySelector('[data-karin-lb-track]');
        if (this._track) this._track.style.transition = 'none';
        if (this._lbMain && this._lbMain.setPointerCapture && e.pointerId != null) {
          try {
            this._lbMain.setPointerCapture(e.pointerId);
          } catch (err) {}
        }
      }
      onLbPointerMove(e) {
        if (!this._dragging || !this._track) return;
        var dx = e.clientX - this._dragX;
        var pct = -this.lbIndex * 100 + (dx / this._mainW) * 100;
        this._track.style.transform = 'translateX(' + pct + '%)';
      }
      onLbPointerUp(e) {
        if (!this._dragging) return;
        this._dragging = false;
        if (this._track) this._track.style.transition = '';
        var dx = e.clientX - this._dragX;
        var dy = e.clientY - this._dragY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          this.navigate(dx < 0 ? 1 : -1);
        } else {
          this.setModalImage(this.lbIndex); // snap back to the current slide
        }
      }

      // Scroll wheel over the image also slides (one image per gesture).
      onLbWheel(e) {
        if (!this.lbImages || this.lbImages.length < 2) return;
        var delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
        if (Math.abs(delta) < 6) return;
        e.preventDefault();
        var now = Date.now();
        if (this._lastWheel && now - this._lastWheel < 350) return;
        this._lastWheel = now;
        this.navigate(delta > 0 ? 1 : -1);
      }

      // Slide to the previous/next image (clamped at the ends so the track never jump-rewinds).
      navigate(delta) {
        if (!this.lbImages || this.lbImages.length < 2) return;
        this.setModalImage(this.lbIndex + delta);
      }

      onModalKeydown(e) {
        if (!this._modal || this._modal.hidden) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          this.closeLightbox();
          return;
        }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.navigate(-1);
          return;
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.navigate(1);
          return;
        }
        if (e.key === 'Tab') {
          // Simple focus trap: keep Tab within the dialog's visible buttons.
          var els = Array.prototype.slice
            .call(this._modal.querySelectorAll('button:not([disabled])'))
            .filter(function (el) {
              return el.offsetParent !== null;
            });
          if (!els.length) return;
          var first = els[0];
          var last = els[els.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      closeLightbox() {
        if (!this._modal || this._modal.hidden) return;
        this._modal.hidden = true;
        document.documentElement.classList.remove('karin-lb-open');
        if (this._lastFocus && typeof this._lastFocus.focus === 'function') {
          this._lastFocus.focus({ preventScroll: true });
        }
        this._lastFocus = null;
      }

      stepQty(btn) {
        var wrap = btn.closest('[data-karin-qty]');
        var input = wrap && wrap.querySelector('input');
        if (!input) return;
        var min = parseInt(input.getAttribute('min') || '1', 10);
        if (isNaN(min)) min = 1;
        var v = parseInt(input.value || '', 10);
        if (isNaN(v)) v = min;
        if (btn.getAttribute('data-karin-qstep') === 'plus') {
          v = v + 1;
        } else {
          v = Math.max(min, v - 1);
        }
        input.value = v;
        var form = btn.closest('.karin-atc');
        if (form) this.toggleAtcError(form, false);
      }

      columnCount() {
        var tmpl = getComputedStyle(this.grid).gridTemplateColumns;
        var n = tmpl.split(' ').filter(Boolean).length;
        return n > 0 ? n : 1;
      }

      visibleTiles() {
        return this.items.filter(function (t) {
          return !t.hidden;
        });
      }

      panelFor(tile) {
        return this.grid.querySelector('.karin-panel[data-colour-id="' + tile.getAttribute('data-colour-id') + '"]');
      }

      togglePanel(tile) {
        if (this.openTile === tile) {
          this.closePanel(true);
          return;
        }
        this.openPanel(tile, true);
      }

      openPanel(tile, userInitiated) {
        var panel = this.panelFor(tile);
        if (!panel) return;
        this.closePanel(false);
        var cols = this.columnCount();
        var visible = this.visibleTiles();
        var i = visible.indexOf(tile);
        if (i === -1) return;
        var rowLast = Math.min(i - (i % cols) + cols - 1, visible.length - 1);
        visible[rowLast].insertAdjacentElement('afterend', panel);
        panel.hidden = false;
        tile.classList.add('is-open');
        tile.setAttribute('aria-expanded', 'true');
        this.openTile = tile;
        this.positionPointer(tile, panel);
        this.applyRowFilters();
        // Fill + reveal the panel's "second image of first linked product" swatch thumbnail when that source
        // is active (no-op for the default "metaobject" source).
        this.resolvePanelSecondImage(panel);
        if (userInitiated) {
          var closeBtn = panel.querySelector('[data-karin-panel-close]');
          if (closeBtn) closeBtn.focus();
        }
      }

      positionPointer(tile, panel) {
        var pointer = panel.querySelector('.karin-panel__pointer');
        if (!pointer) return;
        var tileRect = tile.getBoundingClientRect();
        var panelRect = panel.getBoundingClientRect();
        var x = tileRect.left + tileRect.width / 2 - panelRect.left;
        panel.style.setProperty('--karin-pointer-x', x + 'px');
      }

      closePanel(restoreFocus) {
        if (!this.openTile) return;
        var tile = this.openTile;
        var panel = this.panelFor(tile);
        if (panel) panel.hidden = true;
        tile.classList.remove('is-open');
        tile.setAttribute('aria-expanded', 'false');
        this.openTile = null;
        if (restoreFocus && tile) tile.focus();
      }

      repositionOpen() {
        if (!this.openTile) return;
        var t = this.openTile;
        this.openTile = null;
        this.openPanel(t, false);
      }

      /* ----- Search autocomplete ----- */
      onSearchInput() {
        // Like the reference: show suggestions AND live-filter the swatches as you type. The suggestion
        // list is an absolutely-positioned overlay, the open panel's rows filter in place (no DOM move),
        // and the filter bar reserves the Clear button's slot — so the bar's box height stays constant
        // while the grid narrows.
        this.renderSuggestions();
        this.debouncedFilter();
      }

      renderSuggestions() {
        if (!this.suggestEl) return;
        var q = (this.searchInput.value || '').trim().toLowerCase();
        if (q.length < 1 || !this.index.length) {
          this.closeSuggest();
          return;
        }
        var all = [];
        for (var i = 0; i < this.index.length; i++) {
          var it = this.index[i];
          // Match against the item's `search` blob (brushes: code + shape + size + series) when present,
          // else its label (paints).
          var hay = it && (it.search || it.label);
          if (hay && String(hay).toLowerCase().indexOf(q) !== -1) all.push(it);
        }
        if (!all.length) {
          this.closeSuggest();
          return;
        }
        // Ensure each suggestion TYPE is represented before filling remaining slots, then cap.
        var matches = [];
        var seenType = {};
        for (var a = 0; a < all.length; a++) {
          if (!seenType[all[a].type]) {
            seenType[all[a].type] = true;
            matches.push(all[a]);
          }
        }
        for (var b = 0; b < all.length && matches.length < 12; b++) {
          if (matches.indexOf(all[b]) === -1) matches.push(all[b]);
        }
        this.suggestItems = matches;
        this.activeSuggest = -1;
        var listId = this.suggestEl.id || 'KarinSuggest';
        var html = '';
        for (var j = 0; j < matches.length; j++) {
          var m = matches[j];
          var inner;
          if (m.img) {
            // Brush suggestion: thumbnail image + code, with a muted shape·size·series subtitle.
            inner =
              '<img class="karin-suggest__img" src="' +
              escapeHtml(m.img) +
              '" alt="" loading="lazy">' +
              '<span class="karin-suggest__text"><span class="karin-suggest__label">' +
              escapeHtml(m.label) +
              '</span>' +
              (m.sub ? '<span class="karin-suggest__sub">' + escapeHtml(m.sub) + '</span>' : '') +
              '</span>';
          } else {
            // Text suggestion (paints): type tag + label, unchanged.
            inner =
              '<span class="karin-suggest__type">' +
              escapeHtml(m.type) +
              '</span><span class="karin-suggest__label">' +
              escapeHtml(m.label) +
              '</span>';
          }
          html +=
            '<li class="karin-suggest__item' +
            (m.img ? ' karin-suggest__item--img' : '') +
            '" id="' +
            listId +
            '-opt-' +
            j +
            '" role="option" aria-selected="false" data-idx="' +
            j +
            '">' +
            inner +
            '</li>';
        }
        this.suggestEl.innerHTML = html;
        this.suggestEl.hidden = false;
        if (this.searchInput) this.searchInput.setAttribute('aria-expanded', 'true');
      }

      closeSuggest() {
        if (!this.suggestEl) return;
        this.suggestEl.hidden = true;
        this.suggestEl.innerHTML = '';
        this.suggestItems = [];
        this.activeSuggest = -1;
        if (this.searchInput) {
          this.searchInput.setAttribute('aria-expanded', 'false');
          this.searchInput.removeAttribute('aria-activedescendant');
        }
      }

      moveActive(dir) {
        var n = this.suggestItems.length;
        if (!n) return;
        this.activeSuggest = (this.activeSuggest + dir + n) % n;
        var lis = this.suggestEl.querySelectorAll('[data-idx]');
        for (var i = 0; i < lis.length; i++) {
          var on = i === this.activeSuggest;
          lis[i].classList.toggle('is-active', on);
          lis[i].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        var active = lis[this.activeSuggest];
        if (active && this.searchInput) this.searchInput.setAttribute('aria-activedescendant', active.id);
      }

      onSearchKeydown(e) {
        if (!this.suggestEl || this.suggestEl.hidden) {
          if (e.key === 'Escape' && this.searchInput.value) {
            this.searchInput.value = '';
            this.applyFilters();
          }
          return;
        }
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          this.moveActive(1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          this.moveActive(-1);
        } else if (e.key === 'Enter') {
          e.preventDefault();
          var m = this.suggestItems[this.activeSuggest] || this.suggestItems[0];
          if (m) this.chooseSuggest(m);
        } else if (e.key === 'Escape') {
          this.closeSuggest();
        }
      }

      onSuggestMousedown(e) {
        var li = e.target.closest('[data-idx]');
        if (!li) return;
        e.preventDefault();
        var m = this.suggestItems[parseInt(li.getAttribute('data-idx'), 10)];
        if (m) this.chooseSuggest(m);
      }

      chooseSuggest(m) {
        this.closeSuggest();
        if (this.searchInput) this.searchInput.value = '';
        if (m.kind === 'filter') {
          var sel = this.filters.filter(function (f) {
            return f.getAttribute('data-karin-filter') === m.fkey;
          })[0];
          if (sel) sel.value = m.fval;
          // Search was cleared above, so recompute tiles; applyFilters also re-applies the size-row filter.
          this.applyFilters();
        } else if (m.kind === 'colour') {
          this.applyFilters();
          this.scrollToColour(m.id);
        } else if (m.kind === 'row') {
          this.applyFilters();
          this.scrollToRow(m.id);
        }
      }

      scrollToColour(id) {
        var tile = this.items.filter(function (t) {
          return t.getAttribute('data-colour-id') === id;
        })[0];
        if (!tile || tile.hidden) return;
        tile.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.openPanel(tile, false);
      }

      scrollToRow(id) {
        if (!this.table) return;
        var row = this.table.querySelector('[data-rid="' + id + '"]');
        if (!row || row.hidden) return;
        row.scrollIntoView({ behavior: 'smooth', block: 'center' });
        row.classList.add('karin-flash');
        setTimeout(function () {
          row.classList.remove('karin-flash');
        }, 1600);
      }

      clearAll() {
        this.filters.forEach(function (f) {
          f.value = 'all';
        });
        if (this.searchInput) this.searchInput.value = '';
        this.closeSuggest();
        this.applyFilters();
      }
    }

    customElements.define('karin-variants', KarinVariants);
  })();

  } catch(e) { console.error(e); }
})();
})();
